import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { useWeb3 } from '../contexts/Web3Context';
import { ethers } from 'ethers';
import { FaUserShield, FaCoins, FaHammer, FaCheckCircle, FaUsers, FaSearch, FaExclamationTriangle, FaTimes, FaSave, FaWallet, FaSync, FaCheck, FaCog, FaRobot, FaArrowUp, FaArrowDown, FaClock, FaCopy, FaChartLine } from 'react-icons/fa';
import { db, auth, functions } from '../firebaseConfig';
import { collection, getDocs, getDoc, query, where, orderBy, limit, doc, updateDoc, deleteDoc, setDoc, addDoc, runTransaction, serverTimestamp } from 'firebase/firestore';
import { httpsCallable } from "firebase/functions";
import * as Sentry from "@sentry/react";

import XCoinStakingABI from '../abis/XCoinStaking.json';
import XCoinBNBATMABI from '../abis/XCoinBNBATM.json';
import XCoinBNBBuybackABI from '../abis/XCoinBNBBuyback.json';
import packageJson from '../../package.json';
import { getWalletCLPBalance } from '../utils/walletBalanceHelper';
import BlockchainMonitor from '../components/BlockchainMonitor';
import AnalyticsTab from '../components/AnalyticsTab';


const btnStyle = { padding: '10px 20px', borderRadius: '5px', border: 'none', background: '#ffd700', color: 'black', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' };

// API URL - usa proxy en producción, localhost en desarrollo
const API_URL = window.location.hostname === 'localhost' ? 'http://localhost:5001' : '';

const AdminView = () => {
    // --- GENERAL STATE ---
    const [activeTab, setActiveTab] = useState('dashboard');
    const [loading, setLoading] = useState(false);
    const [statusMsg, setStatusMsg] = useState('');
    const [modalStatusMsg, setModalStatusMsg] = useState(''); // Status specifically for the modal

    // --- CONTEXTS ---
    const web3 = useWeb3();
    const { wallet, contract: contextContract, signer, crowdsaleContract, buybackContract, bnbAtmContract, usdtContract } = web3;

    useEffect(() => {
        console.log("AdminView v3.3.72 - Contrato Buyback:", !!buybackContract);
    }, [buybackContract]);

    // --- DASHBOARD STATS STATE ---
    const [totalSupply, setTotalSupply] = useState('0');
    const [ownerBalance, setOwnerBalance] = useState('0');
    const [ownerAddress, setOwnerAddress] = useState(''); // NEW
    const [crowdsaleBalance, setCrowdsaleBalance] = useState('0');
    const [mintAmount, setMintAmount] = useState('');
    const [mintRecipient, setMintRecipient] = useState('');
    const [stakingBalance, setStakingBalance] = useState('0');
    const [circulatingSupply, setCirculatingSupply] = useState('0');
    const [burnedBalance, setBurnedBalance] = useState('0'); // NEW

    // --- STAKING BREAKDOWN ---
    const [stakingDetail, setStakingDetail] = useState({
        flexible: 0,
        locked30: 0,
        locked90: 0,
        locked180: 0,
        reserve: 0,
        totalLocked: 0
    });

    // --- BUYBACK STATS ---
    const [buybackUSDT, setBuybackUSDT] = useState('0');
    const [buybackXCO, setBuybackXCO] = useState('0');
    const [buybackDepositAmount, setBuybackDepositAmount] = useState(''); // NEW

    const [bnbAtmBalance, setBnbAtmBalance] = useState('0');
    const [bnbTreasuryUSDT, setBnbTreasuryUSDT] = useState('0');
    const [atmRefillAmount, setAtmRefillAmount] = useState('');
    const [atmWithdrawAmount, setAtmWithdrawAmount] = useState('');
    const [bnbPrice, setBnbPrice] = useState('0'); // NEW

    // BNB Buyback Contract (Compra BNB de usuarios)
    const [bnbBuybackUSDT, setBnbBuybackUSDT] = useState('0');
    const [bnbBuybackVaultBNB, setBnbBuybackVaultBNB] = useState('0');
    const [buybackDepositUSDT, setBuybackDepositUSDT] = useState('');
    const [buybackWithdrawUSDT, setBuybackWithdrawUSDT] = useState('');

    // BNB ATM Config (Spread Editable)
    const [bnbSpreadVenta, setBnbSpreadVenta] = useState(2.0); // Default 2%
    const [bnbSpreadCompra, setBnbSpreadCompra] = useState(2.0); // Default 2%
    const [editingBnbSpread, setEditingBnbSpread] = useState(false);
    const [tempBnbSpread, setTempBnbSpread] = useState(2.0);

    // Historial de Transacciones BNB
    const [showHistorialVenta, setShowHistorialVenta] = useState(false);
    const [showHistorialCompra, setShowHistorialCompra] = useState(false);
    const [historialVenta, setHistorialVenta] = useState([]);
    const [historialCompra, setHistorialCompra] = useState([]);
    const [loadingHistorial, setLoadingHistorial] = useState(false);

    // =================================================================================
    // 1. FETCH DASHBOARD STATS (ROBUST VIA RPC)
    // =================================================================================
    // --- CONTRACT ADDRESSES (CONSTANTS) ---
    const XCOIN_ADDR = "0x6508AEB49733f5dAAD56621Bc2AC05193F26b53a";
    const STAKING_ADDR = "0x03A6bb992c962176A8C5E2963a7aC288Cc5AD7CD";
    const CROWDSALE_ADDR = "0xE72203e517B80E3c85176376ad3f557538A8d118";
    const BUYBACK_ADDR = "0x3257ee32CbB390CB65a3638Aa56E77136F9cd178";
    const BNB_EXCHANGE_ADDR = "0x6DeF104b6542d323Ef6a2Bebad60309E85196d95"; // Contrato Unificado (Active)
    const BNB_ATM_ADDR = "0xCCb1a8ed14D409b0472151f144c528d9e517abee"; // v3 (Deprecado)
    const BNB_BUYBACK_ADDR = "0x8B33a9Ede858AaB687134d8919f22cC31954Feb4"; // Compra BNB (Deprecado)
    const OLD_CROWDSALE_ADDR = "0x34bf9e22126f9e24Ad1651145F78f8601d24B21a";

    // --- MULTI-CONTRACT CONFIG ---
    const BNB_ATM_CONTRACTS = [
        { label: 'Unificado (Activo)', address: '0x6DeF104b6542d323Ef6a2Bebad60309E85196d95', active: true },
        { label: 'v3 (Deprecado)', address: '0xCCb1a8ed14D409b0472151f144c528d9e517abee', active: false },
        { label: 'v2 (Histórico)', address: '0x117243d7904EaeF514C9352D307116E5360A4eEA', active: false }
    ];

    const BNB_BUYBACK_CONTRACTS = [
        { label: 'Unificado (Activo)', address: '0x6DeF104b6542d323Ef6a2Bebad60309E85196d95', active: true },
        { label: 'v1 (Deprecado)', address: '0x8B33a9Ede858AaB687134d8919f22cC31954Feb4', active: false }
    ];
    const USDT_ADDR = "0x55d398326f99059fF775485246999027B3197955";

    // --- HELPER: RENDER ADDRESS ---
    const renderContractAddress = (address, label = "Contrato") => {
        if (!address) return null;
        return (
            <div style={{ marginTop: '8px', fontSize: '0.7rem', color: '#aaa', display: 'flex', alignItems: 'center', gap: '6px', background: 'rgba(0,0,0,0.3)', padding: '4px 8px', borderRadius: '4px', width: 'fit-content' }}>
                <span style={{ opacity: 0.7 }}>{label}:</span>
                <span
                    style={{ fontFamily: 'monospace', cursor: 'pointer', color: '#00d2ff', display: 'flex', alignItems: 'center', gap: '4px' }}
                    onClick={() => { navigator.clipboard.writeText(address); alert('Dirección copiada: ' + address); }}
                    title={address}
                >
                    {address.substring(0, 6)}...{address.substring(address.length - 4)} <FaCopy size={10} />
                </span>
            </div>
        );
    };

    const fetchStats = async () => {
        // 1. Definition of Contracts for Read-Only (Robust)
        const RPC_URL = "https://bsc-dataseed.binance.org/";
        // Constants moved to component scope

        try {
            const rpcProvider = new ethers.JsonRpcProvider(RPC_URL);
            const xcoinRead = new ethers.Contract(XCOIN_ADDR, ["function totalSupply() view returns (uint256)", "function balanceOf(address) view returns (uint256)", "function owner() view returns (address)"], rpcProvider);
            const usdtRead = new ethers.Contract(USDT_ADDR, ["function balanceOf(address) view returns (uint256)"], rpcProvider);

            // Fetch All in Parallel
            const ownerAddr = await xcoinRead.owner();
            setOwnerAddress(ownerAddr); // Store Owner Address
            const [supply, ownerBal, csBal, stakingBal, bbXco, bbUsdt, burnedBal] = await Promise.all([
                xcoinRead.totalSupply(),
                xcoinRead.balanceOf(ownerAddr),
                xcoinRead.balanceOf(CROWDSALE_ADDR),
                xcoinRead.balanceOf(STAKING_ADDR),
                xcoinRead.balanceOf(BUYBACK_ADDR),
                usdtRead.balanceOf(BUYBACK_ADDR),
                xcoinRead.balanceOf(OLD_CROWDSALE_ADDR)
            ]);

            setTotalSupply(ethers.formatUnits(supply, 18));
            setOwnerBalance(ethers.formatUnits(ownerBal, 18));
            setCrowdsaleBalance(ethers.formatUnits(csBal, 18));
            setStakingBalance(ethers.formatUnits(stakingBal, 18));
            setBuybackXCO(ethers.formatUnits(bbXco, 18));
            setBuybackUSDT(ethers.formatUnits(bbUsdt, 18));
            setBurnedBalance(ethers.formatUnits(burnedBal, 18));

            // Circulating Supply
            const total = parseFloat(ethers.formatUnits(supply, 18));
            const excluded = parseFloat(ethers.formatUnits(ownerBal, 18)) +
                parseFloat(ethers.formatUnits(csBal, 18)) +
                parseFloat(ethers.formatUnits(stakingBal, 18)) +
                parseFloat(ethers.formatUnits(bbXco, 18)) +
                parseFloat(ethers.formatUnits(burnedBal, 18));
            setCirculatingSupply(total - excluded);

            // BNB Exchange Stats (Contrato Unificado)
            try {
                const exchangeBalance = await rpcProvider.getBalance(BNB_EXCHANGE_ADDR);
                setBnbAtmBalance(ethers.formatUnits(exchangeBalance, 18));

                const atmRead = new ethers.Contract(BNB_EXCHANGE_ADDR, XCoinBNBATMABI.abi, rpcProvider);
                const treasuryAddr = await atmRead.treasuryWallet();
                const trUsdt = await usdtRead.balanceOf(treasuryAddr);
                setBnbTreasuryUSDT(ethers.formatUnits(trUsdt, 18));
            } catch (atmErr) { console.warn("BNB ATM Fetch Error:", atmErr); }

            // BNB Exchange USDT Stats (Mismo Contrato Unificado)
            try {
                const buybackRead = new ethers.Contract(BNB_EXCHANGE_ADDR, XCoinBNBBuybackABI, rpcProvider);
                const buybackUsdtBal = await usdtRead.balanceOf(BNB_EXCHANGE_ADDR);
                setBnbBuybackUSDT(ethers.formatUnits(buybackUsdtBal, 18));

                // Obtener balance BNB del vault
                const vaultAddr = await buybackRead.bnbVault();
                const vaultBnbBal = await rpcProvider.getBalance(vaultAddr);
                setBnbBuybackVaultBNB(ethers.formatUnits(vaultBnbBal, 18));
            } catch (buybackErr) { console.warn("BNB Buyback Fetch Error:", buybackErr); }

            // BNB Price (Live)
            try {
                const updatedPrice = await fetch('https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT')
                    .then(res => res.json())
                    .then(data => parseFloat(data.price));
                setBnbPrice(updatedPrice);
            } catch (e) { console.error("Error fetching BNB Price", e); }


            // Staking Breakdown
            try {
                const stakingRead = new ethers.Contract(STAKING_ADDR, XCoinStakingABI.abi, rpcProvider);
                const [globalFlex, globalLocked] = await Promise.all([
                    stakingRead.totalStakedFlexible().catch(e => 0n),
                    stakingRead.totalStakedLocked().catch(e => 0n)
                ]);

                const flexVal = parseFloat(ethers.formatUnits(globalFlex, 18));
                const lockVal = parseFloat(ethers.formatUnits(globalLocked, 18));
                const totalStakingVal = parseFloat(ethers.formatUnits(stakingBal, 18));
                let reserveVal = totalStakingVal - (flexVal + lockVal);
                if (reserveVal < 0) reserveVal = 0;

                setStakingDetail({
                    flexible: flexVal,
                    locked30: 0,
                    locked90: 0,
                    locked180: 0,
                    totalLocked: lockVal,
                    reserve: reserveVal
                });

                // Detailed User Iteration (Admin Mode)
                try {
                    const qUsers = query(collection(db, 'usuarios'));
                    const snapUsers = await getDocs(qUsers);
                    let big30 = 0n, big90 = 0n, big180 = 0n;

                    const stakers = snapUsers.docs
                        .map(d => d.data().walletAddress)
                        .filter(addr => addr && ethers.isAddress(addr));

                    const promises = stakers.map(async (addr) => {
                        try {
                            const deposits = await stakingRead.getLockedDeposits(addr);
                            deposits.forEach(dep => {
                                if (!dep.withdrawn) {
                                    if (dep.period == 0n) big30 += dep.amount;
                                    else if (dep.period == 1n) big90 += dep.amount;
                                    else if (dep.period == 2n) big180 += dep.amount;
                                }
                            });
                        } catch (err) { }
                    });

                    await Promise.all(promises);
                    setStakingDetail({
                        flexible: flexVal,
                        locked30: parseFloat(ethers.formatUnits(big30, 18)),
                        locked90: parseFloat(ethers.formatUnits(big90, 18)),
                        locked180: parseFloat(ethers.formatUnits(big180, 18)),
                        totalLocked: lockVal,
                        reserve: reserveVal
                    });

                } catch (iterErr) { console.error("User Iteration Failed:", iterErr); }

            } catch (err) { console.error("Critical Staking Fetch Error:", err); }

        } catch (error) {
            console.error("Error loading stats:", error);
        }
    };

    // --- VERIFICATIONS STATE ---
    const [verifications, setVerifications] = useState([]);
    const [depositAmount, setDepositAmount] = useState('');
    const [selectedRequest, setSelectedRequest] = useState(null);

    // --- USERS STATE ---
    const [usersList, setUsersList] = useState([]);
    const [leadsList, setLeadsList] = useState([]); // NEW: Store raw leads for counting
    const [searchTerm, setSearchTerm] = useState('');

    // --- USER EDIT MODAL STATE ---
    const [editingUser, setEditingUser] = useState(null);
    const [editForm, setEditForm] = useState({
        verificationStatus: '',
        verificationAttempts: 0,
        bloqueado: false
    });

    const [userXcoBalance, setUserXcoBalance] = useState('Checking...');
    const [userChainData, setUserChainData] = useState({}); // { uid: { total, wallet, flexible, locked } }
    const [userWalletCLPBalances, setUserWalletCLPBalances] = useState({}); // { uid: clpBalance } from wallets collection
    const [modalLockedDetails, setModalLockedDetails] = useState({ loading: false, deposits: [] });
    // REFERRALS
    const [referralCounts, setReferralCounts] = useState({}); // { walletAddress: count }
    const [referralDetails, setReferralDetails] = useState({ loading: false, stats: { invited: 0, registered: 0, investors: 0 }, list: [] });
    // COMUNICACIÓN MASIVA
    const [showComunicacionModal, setShowComunicacionModal] = useState(false);
    const [comunicacionForm, setComunicacionForm] = useState({ tipo: 'anuncio', asunto: '', mensaje: '' });

    useEffect(() => { if (activeTab === 'dashboard') fetchStats(); }, [activeTab]);

    // LOAD BNB ATM CONFIG (Spread)
    useEffect(() => {
        const loadBNBConfig = async () => {
            try {
                const configRef = doc(db, 'configuracion_cajeros', 'BNB_ATM');
                const configSnap = await getDoc(configRef);
                if (configSnap.exists()) {
                    const data = configSnap.data();
                    setBnbSpreadVenta((data.spread_venta || 0.02) * 100);
                    setBnbSpreadCompra((data.spread_compra || 0.02) * 100);
                }
            } catch (error) {
                console.warn('Error loading BNB ATM config:', error);
            }
        };
        if (activeTab === 'dashboard') loadBNBConfig();
    }, [activeTab]);

    // FETCH USERS CHAIN DATA (BATCH)
    useEffect(() => {
        if (usersList.length > 0) {
            fetchBatchChainData();
            fetchBatchWalletCLPBalances();
        }
    }, [usersList]);

    const fetchBatchChainData = async () => {
        const RPC_URL = "https://bsc-dataseed.binance.org/";
        const XCOIN_ADDR = "0x6508AEB49733f5dAAD56621Bc2AC05193F26b53a";
        const STAKING_ADDR = "0x03A6bb992c962176A8C5E2963a7aC288Cc5AD7CD";

        try {
            const rpcProvider = new ethers.JsonRpcProvider(RPC_URL);
            const xcoinRead = new ethers.Contract(XCOIN_ADDR, ["function balanceOf(address) view returns (uint256)"], rpcProvider);
            const stakingRead = new ethers.Contract(STAKING_ADDR, XCoinStakingABI.abi, rpcProvider);

            const usersWithWallet = usersList.filter(u => u.walletAddress && ethers.isAddress(u.walletAddress));

            // Process in chunks to avoid spamming (Though for < 50 users Promise.all is fine)
            const updates = {};

            await Promise.all(usersWithWallet.map(async (u) => {
                try {
                    const [walletBal, flexStaker, lockedBal] = await Promise.all([
                        xcoinRead.balanceOf(u.walletAddress).catch(() => 0n),
                        stakingRead.flexibleStakers(u.walletAddress).catch(() => ({ amount: 0n })),
                        stakingRead.lockedStakingBalance(u.walletAddress).catch(() => 0n)
                    ]);

                    const w = parseFloat(ethers.formatUnits(walletBal, 18));
                    const f = parseFloat(ethers.formatUnits(flexStaker.amount || 0n, 18)); // Struct return or zero
                    const l = parseFloat(ethers.formatUnits(lockedBal, 18));
                    const t = w + f + l;

                    updates[u.id] = {
                        wallet: w,
                        flexible: f,
                        locked: l,
                        total: t
                    };
                } catch (e) { console.warn("Fetch Error for", u.email, e); }
            }));

            setUserChainData(prev => ({ ...prev, ...updates }));

        } catch (error) {
            console.error("Batch Fetch Error:", error);
        }
    };

    const fetchBatchWalletCLPBalances = async () => {
        try {
            const balances = {};

            await Promise.all(usersList.map(async (u) => {
                try {
                    const balance = await getWalletCLPBalance(u.id);
                    balances[u.id] = balance;
                } catch (error) {
                    console.error(`Error fetching wallet CLP balance for ${u.id}:`, error);
                    balances[u.id] = 0;
                }
            }));

            setUserWalletCLPBalances(balances);
        } catch (error) {
            console.error("Batch Wallet CLP Fetch Error:", error);
        }
    };

    // CALCULATE REFERRALS (LOCAL + BATCH)
    useEffect(() => {
        if (usersList.length > 0 || leadsList.length > 0) {
            const counts = {};
            const registeredEmails = new Set();

            // 1. Count Registered Users (Source of Truth)
            usersList.forEach(u => {
                if (u.email) registeredEmails.add(u.email.toLowerCase());
                if (u.referredBy && ethers.isAddress(u.referredBy)) {
                    const referee = u.referredBy.toLowerCase(); // NORMALIZE
                    counts[referee] = (counts[referee] || 0) + 1;
                }
            });

            // 2. Count Leads (Invitados) - Only if NOT already registered
            leadsList.forEach(l => {
                const email = (l.email || '').toLowerCase();
                // Deduplicate: If lead became a user, don't double count
                if (!registeredEmails.has(email)) {
                    if (l.referrerAddress && ethers.isAddress(l.referrerAddress) && l.status === 'pending') {
                        const referee = l.referrerAddress.toLowerCase(); // NORMALIZE
                        counts[referee] = (counts[referee] || 0) + 1;
                    }
                }
            });

            setReferralCounts(counts);
        }
    }, [usersList, leadsList]);

    const fetchReferralDetails = async (walletAddress, walletHistory = []) => {
        setReferralDetails({ loading: true, stats: { invited: 0, registered: 0, investors: 0 }, list: [] });

        // Build set of ALL wallets (current + historical) for local search
        const allWallets = new Set();
        if (walletAddress) allWallets.add(walletAddress.toLowerCase());
        if (walletHistory && Array.isArray(walletHistory)) {
            walletHistory.forEach(w => { if (w) allWallets.add(w.toLowerCase()); });
        }

        // 1. CALCULATE LOCAL (Registered Users - The source of truth for the Table)
        const localRegistered = usersList.filter(u =>
            u.referredBy && allWallets.has(u.referredBy.toLowerCase())
        ).map(u => ({
            email: u.email,
            status: 'Registrado',
            wallet: u.walletAddress,
            id: u.id,
            source: 'local'
        }));

        let combined = [...localRegistered];

        // 2. FETCH CLOUD (Leads + Potential Extra Registered)
        try {
            const getRefFn = httpsCallable(functions, 'obtenerMisReferidos');
            const res = await getRefFn({ walletAddress, walletHistory });

            if (res.data && res.data.success) {
                const { leads, registered: cloudRegistered } = res.data.data;

                // A. Add Leads (Invitados)
                leads.forEach(l => {
                    if (l.status === 'pending') {
                        // Avoid duplicates if any
                        if (!combined.some(c => c.email.toLowerCase() === l.email.toLowerCase())) {
                            combined.push({ email: l.email, status: 'Invitado', wallet: null, source: 'cloud_lead' });
                        }
                    }
                });

                // B. Merge Cloud Registered (might be more updated or same)
                cloudRegistered.forEach(r => {
                    const existingIdx = combined.findIndex(c => c.wallet === r.walletAddress || c.email === r.email);
                    if (existingIdx === -1) {
                        combined.push({ email: r.email, status: 'Registrado', wallet: r.walletAddress, source: 'cloud_reg' });
                    }
                });
            }
        } catch (e) {
            console.warn("Cloud fetch failed/skipped, showing local only", e);
        }

        // 3. ENRICH WITH INVESTOR STATUS (Available for all)
        const enriched = combined.map(item => {
            // Check Investor Status via Chain Data matches
            // We need a way to link item to userChainData. 
            // If we have ID (local) easy. If not (cloud), try to find in usersList by wallet.
            let isInvestor = false;
            let uid = item.id;

            if (!uid && item.wallet) {
                const u = usersList.find(x => x.walletAddress?.toLowerCase() === item.wallet.toLowerCase());
                if (u) uid = u.id;
            }

            if (uid && userChainData[uid] && userChainData[uid].total > 0) {
                isInvestor = true;
            }

            // Update status if Investor, unless it's just 'Invitado' (leads can't be investors yet usually)
            return {
                ...item,
                status: isInvestor ? 'Inversionista' : item.status
            };
        });

        setReferralDetails({
            loading: false,
            stats: {
                invited: enriched.filter(x => x.status === 'Invitado').length,
                registered: enriched.filter(x => x.status === 'Registrado').length,
                investors: enriched.filter(x => x.status === 'Inversionista').length
            },
            list: enriched
        });
    };

    const fetchModalLockedDetails = async (address) => {
        if (!address) return;
        setModalLockedDetails({ loading: true, deposits: [] });
        const RPC_URL = "https://bsc-dataseed.binance.org/";
        const STAKING_ADDR = "0x03A6bb992c962176A8C5E2963a7aC288Cc5AD7CD";

        try {
            const rpcProvider = new ethers.JsonRpcProvider(RPC_URL);
            const stakingRead = new ethers.Contract(STAKING_ADDR, XCoinStakingABI.abi, rpcProvider);

            const deposits = await stakingRead.getLockedDeposits(address);

            const formatted = deposits
                .filter(d => !d.withdrawn) // Only active
                .map(d => {
                    const unlockDate = new Date(Number(d.unlockTime) * 1000);
                    return {
                        amount: ethers.formatUnits(d.amount, 18),
                        period: Number(d.period),
                        unlockTime: Number(d.unlockTime),
                        unlockDate: unlockDate.toLocaleDateString('es-CL'),
                        isUnlocked: Date.now() > unlockDate.getTime()
                    };
                })
                .sort((a, b) => a.unlockTime - b.unlockTime); // Sort by soonest to release

            setModalLockedDetails({ loading: false, deposits: formatted });

        } catch (e) {
            console.error(e);
            setModalLockedDetails({ loading: false, deposits: [] });
        }
    };

    const safeFmt = (val) => {
        if (val === 'Error') return 'Error conexión';
        if (isNaN(parseFloat(val))) return val;
        return parseFloat(val).toLocaleString();
    };

    // =================================================================================
    // 2. MINT & WITHDRAW LOGIC
    // =================================================================================
    const handleMint = async (e) => {
        e.preventDefault();
        if (!mintAmount || !signer) return;
        setLoading(true);
        setStatusMsg('⏳ Minting en proceso...');
        try {
            const amountWei = ethers.parseUnits(mintAmount, 18);
            const toAddress = mintRecipient || wallet.accounts[0].address;
            const tx = await contextContract.connect(signer).mint(toAddress, amountWei);
            await tx.wait();
            setStatusMsg(`✅ Éxito! ${mintAmount} XCO creados.`);
            setMintAmount('');
            fetchStats();
        } catch (err) {
            console.error(err);
            setStatusMsg('❌ Error al crear tokens: ' + (err.reason || err.message));
        } finally { setLoading(false); }
    };

    const handleDepositBuyback = async () => {
        if (!usdtContract || !buybackContract || !buybackDepositAmount) return;
        setLoading(true);
        setStatusMsg('⏳ Recargando Liquidez USDT...');
        try {
            const amountWei = ethers.parseUnits(buybackDepositAmount, 18);
            const buybackAddress = await buybackContract.getAddress();

            // Direct Transfer of USDT to Buyback Contract
            const tx = await usdtContract.transfer(buybackAddress, amountWei);

            await tx.wait();
            setStatusMsg(`✅ Recarga exitosa: ${buybackDepositAmount} USDT.`);
            setBuybackDepositAmount('');
            fetchStats();
        } catch (err) {
            console.error(err);
            setStatusMsg('❌ Error en recarga: ' + (err.reason || err.message));
        } finally { setLoading(false); }
    };

    // Depositar USDT al contrato BNB Buyback (Compra BNB)
    const handleDepositBnbBuyback = async () => {
        if (!usdtContract || !buybackDepositUSDT) {
            alert('⚠️ Ingresa una cantidad válida');
            return;
        }
        setLoading(true);
        setStatusMsg('⏳ Depositando USDT al Cajero de Compra BNB...');
        try {
            const amountWei = ethers.parseUnits(buybackDepositUSDT, 18);
            const tx = await usdtContract.transfer(BNB_EXCHANGE_ADDR, amountWei);
            const receipt = await tx.wait();

            // Registrar movimiento en historial
            await fetch(`${API_URL}/api-bnb/movimiento`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    cajero: 'compra',
                    tipo: 'deposito',
                    usdtAmount: parseFloat(buybackDepositUSDT),
                    bnbAmount: 0,
                    userAddress: wallet?.accounts?.[0]?.address || 'admin',
                    txHash: receipt.hash,
                    timestamp: Math.floor(Date.now() / 1000),
                    contractAddress: BNB_EXCHANGE_ADDR
                })
            });

            setStatusMsg(`✅ Depósito exitoso: ${buybackDepositUSDT} USDT al Cajero de Compra BNB.`);
            setBuybackDepositUSDT('');
            fetchStats();
        } catch (err) {
            console.error(err);
            let errorMsg = '❌ Error en depósito';
            if (err.code === 'INSUFFICIENT_FUNDS' || err.message?.includes('insufficient funds')) {
                errorMsg = '❌ Fondos insuficientes en tu billetera. Necesitas más USDT para realizar este depósito.';
            } else if (err.code === 'ACTION_REJECTED' || err.code === 4001) {
                errorMsg = '❌ Transacción cancelada por el usuario.';
            } else {
                errorMsg = '❌ Error en depósito: ' + (err.reason || err.shortMessage || 'Error desconocido');
            }
            setStatusMsg(errorMsg);
        } finally { setLoading(false); }
    };

    const handleWithdrawUSDT = async () => {
        if (!bnbAtmContract || !buybackWithdrawUSDT) {
            alert('⚠️ Ingresa una cantidad válida');
            return;
        }
        setLoading(true);
        setStatusMsg('⏳ Retirando USDT del Cajero...');
        try {
            const amountWei = ethers.parseUnits(buybackWithdrawUSDT, 18);
            const tx = await bnbAtmContract.withdrawUSDT(amountWei);
            const receipt = await tx.wait();

            // Registrar movimiento en historial
            await fetch(`${API_URL}/api-bnb/movimiento`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    cajero: 'compra',
                    tipo: 'retiro',
                    usdtAmount: parseFloat(buybackWithdrawUSDT),
                    bnbAmount: 0,
                    userAddress: wallet?.accounts?.[0]?.address || 'admin',
                    txHash: receipt.hash,
                    timestamp: Math.floor(Date.now() / 1000),
                    contractAddress: BNB_EXCHANGE_ADDR
                })
            });

            setStatusMsg(`✅ Retiro exitoso: ${buybackWithdrawUSDT} USDT.`);
            setBuybackWithdrawUSDT('');
            fetchStats();
        } catch (err) {
            console.error(err);
            let errorMsg = '❌ Error en retiro';
            if (err.code === 'INSUFFICIENT_FUNDS' || err.message?.includes('insufficient funds')) {
                errorMsg = '❌ Fondos insuficientes en el contrato.';
            } else if (err.code === 'ACTION_REJECTED' || err.code === 4001) {
                errorMsg = '❌ Transacción cancelada por el usuario.';
            } else {
                errorMsg = '❌ Error en retiro: ' + (err.reason || err.shortMessage || 'Error desconocido');
            }
            setStatusMsg(errorMsg);
        } finally { setLoading(false); }
    };

    const handleWithdrawBuybackAll = async (type) => {
        if (!buybackContract) {
            alert("⚠️ Error: El contrato de Liquidez (Buyback) no está inicializado. Por favor reconecta tu billetera.");
            return;
        }

        const rawAmount = (type === 'USDT' ? buybackUSDT : buybackXCO).toString().replace(',', '');
        const amountNum = parseFloat(rawAmount);

        if (isNaN(amountNum) || amountNum <= 0) {
            alert(`⚠️ No hay saldo de ${type} para retirar (Saldo: ${rawAmount}).`);
            return;
        }

        if (!confirm(`¿Seguro que quieres retirar TODOS los ${type} del Cajero Automático?\nMonto: ${rawAmount} ${type}`)) return;

        setLoading(true);
        setStatusMsg(`⏳ Retirando ${type}...`);
        try {
            const balWei = ethers.parseUnits(rawAmount, 18);
            let tx;
            if (type === 'USDT') {
                tx = await buybackContract.withdrawUSDT(balWei);
            } else {
                tx = await buybackContract.withdrawXCoin(balWei);
            }
            const receipt = await tx.wait();
            
            // Registrar movimiento en historial (solo para USDT)
            if (type === 'USDT') {
                try {
                    await fetch(`${API_URL}/api-bnb/movimiento`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            cajero: 'compra',
                            tipo: 'retiro',
                            usdtAmount: amountNum,
                            bnbAmount: 0,
                            userAddress: wallet?.accounts?.[0]?.address || 'admin',
                            txHash: receipt.hash,
                            timestamp: Math.floor(Date.now() / 1000),
                            contractAddress: BNB_EXCHANGE_ADDR
                        })
                    });
                } catch (logErr) {
                    console.error('Error registrando movimiento:', logErr);
                }
            }
            
            setStatusMsg(`✅ Retiro exitoso.`);
            alert(`✅ Retiro de ${type} completado con éxito.`);
            fetchStats();
        } catch (err) {
            console.error(err);
            const msg = (err.reason || err.message || 'Error desconocido');
            setStatusMsg('❌ Error en retiro: ' + msg);
            alert('❌ EL RETIRO FALLÓ: ' + msg);
        } finally { setLoading(false); }
    };

    // --- BNB ATM MANAGEMENT ---
    const handleRefillBNB = async (e) => {
        e.preventDefault();
        if (!atmRefillAmount || !signer) return;
        setLoading(true);
        setStatusMsg('⏳ Recargando Cajero BNB...');
        try {
            // Simple Transfer: Signer -> Contract
            const tx = await signer.sendTransaction({
                to: BNB_EXCHANGE_ADDR, // Contrato Unificado
                value: ethers.parseEther(atmRefillAmount)
            });
            const receipt = await tx.wait();

            // Registrar movimiento en historial
            await fetch(`${API_URL}/api-bnb/movimiento`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    cajero: 'venta',
                    tipo: 'carga',
                    amount: parseFloat(atmRefillAmount),
                    txHash: receipt.hash,
                    timestamp: Math.floor(Date.now() / 1000)
                })
            });

            setStatusMsg(`✅ Recarga exitosa: ${atmRefillAmount} BNB.`);
            setAtmRefillAmount('');
            fetchStats();
        } catch (err) {
            console.error(err);
            let errorMsg = '❌ Error en recarga';
            if (err.code === 'INSUFFICIENT_FUNDS' || err.message?.includes('insufficient funds')) {
                errorMsg = '❌ Fondos insuficientes en tu billetera. Necesitas más BNB para realizar este depósito.';
            } else if (err.code === 'ACTION_REJECTED' || err.code === 4001) {
                errorMsg = '❌ Transacción cancelada por el usuario.';
            } else {
                errorMsg = '❌ Error en recarga: ' + (err.reason || err.shortMessage || 'Error desconocido');
            }
            setStatusMsg(errorMsg);
        } finally { setLoading(false); }
    };

    const handleWithdrawBNB = async () => {
        if (!bnbAtmContract || !atmWithdrawAmount) return;
        setLoading(true);
        setStatusMsg('⏳ Retirando BNB del Cajero...');
        try {
            const amountWei = ethers.parseEther(atmWithdrawAmount);
            const tx = await bnbAtmContract.withdrawBNB(amountWei);
            const receipt = await tx.wait();

            // Registrar movimiento en historial
            await fetch(`${API_URL}/api-bnb/movimiento`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    cajero: 'venta',
                    tipo: 'retiro',
                    amount: parseFloat(atmWithdrawAmount),
                    txHash: receipt.hash,
                    timestamp: Math.floor(Date.now() / 1000)
                })
            });

            setStatusMsg(`✅ Retiro exitoso.`);
            setAtmWithdrawAmount('');
            fetchStats();
        } catch (err) {
            console.error(err);
            setStatusMsg('❌ Error en retiro: ' + (err.reason || err.message));
        } finally { setLoading(false); }
    };

    // --- BNB ATM SPREAD MANAGEMENT ---
    const handleSaveBnbSpread = async () => {
        if (!tempBnbSpread || tempBnbSpread < 0 || tempBnbSpread > 100) {
            alert('⚠️ El spread debe estar entre 0% y 100%');
            return;
        }

        setLoading(true);
        setStatusMsg('💾 Guardando configuración de spread...');

        console.log('🔧 Intentando guardar spread:', tempBnbSpread);
        console.log('👤 Usuario actual:', auth.currentUser?.email);

        try {
            const configRef = doc(db, 'configuracion_cajeros', 'BNB_ATM');

            const configData = {
                nombre: 'Cajero BNB',
                moneda: 'BNB',
                simbolo: 'BNB',
                activo: true,
                contrato_venta: '0x6DeF104b6542d323Ef6a2Bebad60309E85196d95',
                contrato_compra: '0x6DeF104b6542d323Ef6a2Bebad60309E85196d95',
                spread_venta: tempBnbSpread / 100,
                spread_compra: tempBnbSpread / 100,
                ultima_actualizacion: serverTimestamp(),
                actualizado_por: auth.currentUser?.email || 'admin',
                notas: 'Configuración del cajero ATM de BNB'
            };

            console.log('📝 Datos a guardar:', configData);

            // Usar setDoc con merge para crear el documento si no existe
            await setDoc(configRef, configData, { merge: true });

            console.log('✅ Documento guardado exitosamente');

            setBnbSpreadVenta(tempBnbSpread);
            setBnbSpreadCompra(tempBnbSpread);
            setEditingBnbSpread(false);
            setStatusMsg('✅ Spread actualizado correctamente');
            alert('✅ Spread guardado: ' + tempBnbSpread.toFixed(2) + '%');
        } catch (err) {
            console.error('❌ Error completo al guardar spread:', err);
            console.error('❌ Error code:', err.code);
            console.error('❌ Error message:', err.message);
            console.error('❌ Error stack:', err.stack);

            let errorMsg = 'Error desconocido';
            if (err.code === 'permission-denied') {
                errorMsg = 'Permisos denegados. Verifica las reglas de Firestore.';
            } else if (err.code === 'unavailable') {
                errorMsg = 'Firestore no disponible. Verifica tu conexión.';
            } else {
                errorMsg = err.message || err.toString();
            }

            setStatusMsg('❌ Error: ' + errorMsg);
            alert('❌ Error al guardar: ' + errorMsg);
        } finally {
            setLoading(false);
        }
    };

    // --- HISTORIAL DE TRANSACCIONES BNB (DESDE API POSTGRESQL) ---
    const [selectedAtmContract, setSelectedAtmContract] = useState(BNB_ATM_CONTRACTS[0].address);

    // Effect: Refetch history when contract selection changes
    useEffect(() => {
        if (showHistorialVenta) fetchHistorialVenta();
    }, [selectedAtmContract]);

    const fetchHistorialVenta = async () => {
        setLoadingHistorial(true);
        try {
            // Leer desde API (PostgreSQL en VPS) filtrando por contrato
            const response = await fetch(`${API_URL}/api-bnb/historial/venta?limit=100&contract=${selectedAtmContract}`);
            const result = await response.json();

            if (result.success || Array.isArray(result)) {
                setHistorialVenta(result.data || result);
            } else {
                setHistorialVenta([]);
                console.error("Error historial:", result.error);
            }
        } catch (error) {
            console.error('Error fetching historial:', error);
            setHistorialVenta([]);
        } finally {
            setLoadingHistorial(false);
        }
    };

    const [selectedBuybackContract, setSelectedBuybackContract] = useState(BNB_BUYBACK_CONTRACTS[0].address);

    // Effect: Refetch buyback history when contract selection changes
    useEffect(() => {
        if (showHistorialCompra) fetchHistorialCompra();
    }, [selectedBuybackContract]);

    const fetchHistorialCompra = async () => {
        setLoadingHistorial(true);
        try {
            // Leer desde API (PostgreSQL en VPS)
            const response = await fetch(`${API_URL}/api-bnb/historial/compra?limit=100&contract=${selectedBuybackContract}`);
            const result = await response.json();

            if (result.success || Array.isArray(result)) {
                setHistorialCompra(result.data || result);
            } else {
                setHistorialCompra([]);
                console.error("Error historial compra:", result.error);
            }
        } catch (error) {
            console.error('Error fetching historial compra:', error);
            setHistorialCompra([]);
        } finally {
            setLoadingHistorial(false);
        }
    };

    // =================================================================================
    // 3. FETCH VERIFICATIONS
    // =================================================================================
    const fetchVerifications = async () => {
        setLoading(true);
        try {
            const q = query(collection(db, 'solicitudes_verificacion'), where('status', '==', 'pending'));
            const snapshot = await getDocs(q);
            const docs = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            setVerifications(docs);
        } catch (error) { console.error("Error fetching verifications:", error); }
        finally { setLoading(false); }
    };

    useEffect(() => { if (activeTab === 'verificaciones') fetchVerifications(); }, [activeTab]);

    const handleConfirmDeposit = async (req) => {
        if (!depositAmount) { alert("Ingresa el monto transferido."); return; }
        setLoading(true);
        try {
            const amountInt = parseInt(depositAmount);

            // 1. Update User Doc
            const userRef = doc(db, 'usuarios', req.uid);
            await updateDoc(userRef, {
                verificationAmount: amountInt,
                verificationStatus: 'pending_validation', // Changed from 'pending' to 'pending_validation'
                verificationAttempts: 0 // Reset attempts
            });

            // 2. Update Request (or delete it? Let's keep it as history)
            const reqRef = doc(db, 'solicitudes_verificacion', req.id);
            await updateDoc(reqRef, {
                status: 'deposit_sent',
                depositAmount: amountInt,
                processedAt: new Date()
            });

            // 3. Send Email Notification
            try {
                const sendVerificationEmail = httpsCallable(functions, 'sendVerificationEmail');
                await sendVerificationEmail({
                    email: req.email,
                    amount: amountInt,
                    bankAccount: req.bankAccount
                });
            } catch (emailError) {
                console.error("Error sending email:", emailError);
                // Don't fail the whole process if email fails
            }

            alert(`✅ Depósito registrado($${amountInt}). Email enviado al usuario.`);
            setDepositAmount('');
            setSelectedRequest(null);
            fetchVerifications();
        } catch (err) {
            console.error(err);
            alert("Error al procesar.");
        } finally { setLoading(false); }
    };


    // =================================================================================
    // 4. FETCH ALL USERS & MANAGEMENT
    // =================================================================================
    const fetchUsers = async () => {
        setLoading(true);
        try {
            // 1. Fetch Users (Critical)
            const snapshot = await getDocs(collection(db, 'usuarios'));
            const docs = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            setUsersList(docs);

            // 2. Fetch Leads (Optional / Parallel) - Don't break if this fails
            try {
                const leadsSnap = await getDocs(collection(db, 'referral_leads'));
                const lDocs = leadsSnap.docs.map(d => d.data());
                setLeadsList(lDocs);
            } catch (leadError) {
                console.warn("Could not fetch referral_leads (maybe permissions?):", leadError);
                // Leads stay empty, but users are shown.
            }

        } catch (error) { console.error("Error fetching users:", error); }
        finally { setLoading(false); }
    };

    useEffect(() => { if (activeTab === 'usuarios') fetchUsers(); }, [activeTab]);

    // --- Open Modal & Fetch Real-time Data ---
    const [userTransactions, setUserTransactions] = useState([]);
    const [historyBalance, setHistoryBalance] = useState(0);

    const fetchUserHistory = async (uid) => {
        try {
            const API_URL = import.meta.env.VITE_API_URL || 'https://dashboard.xcoin.cl';

            // 1. Fetch Manual History from PostgreSQL (wallets_history)
            const whRes = await fetch(`${API_URL}/api/wallets/history?uid=${uid}&limit=500`);
            const whData = await whRes.json();
            const manualDocs = (whData.data || []).map(d => ({
                id: d.id,
                type: d.type,
                amount: d.amount,
                description: d.description || '',
                adminEmail: d.adminEmail || '',
                timestamp: d.fecha ? new Date(d.fecha) : new Date(),
                status: 'completed',
                source: 'manual'
            }));

            // 2. Fetch Trades from PostgreSQL (transacciones)
            const txRes = await fetch(`${API_URL}/api/transacciones?userId=${uid}&limit=500`);
            const txData = await txRes.json();

            // Filter out Web3 USDT transactions AND Staking
            const filteredTx = (txData.data || []).filter(tx => {
                if (tx.method === 'Web3 (USDT)') return false;
                if (tx.origen && tx.origen.toLowerCase() === 'staking') return false;
                const typeStr = (tx.tipo || '').toLowerCase();
                if (typeStr.includes('staking') || typeStr.includes('plazo fijo') || typeStr.includes('recompensa')) return false;
                return true;
            });

            const tradeDocs = filteredTx.filter(tx => tx.montoCLP > 0).map(tx => {
                // Determine Type (compra OR compra_bnb = withdrawal)
                const isWithdrawal = tx.tipo === 'compra' || tx.tipo === 'compra_bnb';

                // Determine Description
                let description = `Operación (${tx.tipo})`;
                if (tx.tipo === 'compra') description = `Compra XCO (${tx.cantidad})`;
                else if (tx.tipo === 'compra_bnb') description = `Compra BNB (${tx.cantidad})`;
                else description = `Venta ${tx.moneda || 'XCO'} (${tx.cantidad})`;

                return {
                    id: tx.id,
                    type: isWithdrawal ? 'withdrawal' : 'deposit',
                    description: description,
                    amount: tx.montoCLP,
                    timestamp: tx.fecha ? new Date(tx.fecha) : new Date(),
                    status: 'completed',
                    source: 'trade',
                    origen: tx.origen,
                    tipo: tx.tipo
                };
            });

            // 3. Merge & Sort OLDER -> NEWER (Ascending) for Forward Calc
            const combined = [...manualDocs, ...tradeDocs];
            combined.sort((a, b) => {
                const tA = a.timestamp instanceof Date ? a.timestamp.getTime() : (a.timestamp?.seconds ? a.timestamp.seconds * 1000 : 0);
                const tB = b.timestamp instanceof Date ? b.timestamp.getTime() : (b.timestamp?.seconds ? b.timestamp.seconds * 1000 : 0);
                return tA - tB; // Oldest First
            });

            // 4. Calculate Running Balance Forward (0 -> Present)
            let runningBalance = 0;
            const historyWithBalance = combined.map(tx => {
                const amount = parseFloat(tx.amount) || 0;
                if (tx.type === 'deposit') runningBalance += amount;
                else if (tx.type === 'withdrawal') runningBalance -= amount;

                return {
                    ...tx,
                    resultingBalance: runningBalance,
                    computedBalance: runningBalance
                };
            });

            setHistoryBalance(runningBalance);

            // 5. Reverse for Display (Newest First)
            setUserTransactions(historyWithBalance.reverse());

            // RETURN THE FINAL BALANCE AND THE TRANSACTIONS
            return { history: historyWithBalance, finalBalance: runningBalance };

        } catch (e) { console.error("Error fetching history:", e); return { history: [], finalBalance: 0 }; }
    };

    const [walletRealBalance, setWalletRealBalance] = useState(null); // Nuevo estado para saldo real

    const handleEditUser = async (user) => {
        setEditingUser(user);
        setWalletRealBalance(null); // Reset

        // 1. Fetch REAL Wallet Info (Source of Truth for Client)
        try {
            const walletRef = doc(db, 'wallets', user.id);
            const walletSnap = await getDoc(walletRef);
            if (walletSnap.exists()) {
                const wData = walletSnap.data();
                setWalletRealBalance(wData.balances?.CLP || 0);
            } else {
                setWalletRealBalance(0);
            }
        } catch (e) {
            console.error("Error fetching real wallet:", e);
        }

        // Initial State from DB
        setEditForm({
            verificationStatus: user.verificationStatus || 'unverified',
            verificationAttempts: user.verificationAttempts || 0,
            bloqueado: user.bloqueado || false
        });

        setUserXcoBalance('Cargando...');

        // Fetch & Calculate History Truth
        await fetchUserHistory(user.id);

        if (user.walletAddress) {
            fetchModalLockedDetails(user.walletAddress); // FETCH LOCKED DETAILS
        } else {
            setModalLockedDetails({ loading: false, deposits: [] });
        }

        // FETCH REFERRAL DETAILS using walletHistory (even if current wallet is null)
        const history = user.walletHistory || [];
        if (user.walletAddress || history.length > 0) {
            fetchReferralDetails(user.walletAddress, history);
        } else {
            setReferralDetails({ loading: false, stats: { invited: 0, registered: 0, investors: 0 }, list: [] });
        }

        if (user.walletAddress && contextContract) {
            try {
                const bal = await contextContract.balanceOf(user.walletAddress);
                setUserXcoBalance(ethers.formatUnits(bal, 18) + ' XCO');
            } catch (e) {
                console.error(e);
                setUserXcoBalance('Error reading chain');
            }
        } else {
            setUserXcoBalance('Sin Billetera');
        }
    };

    // --- TRANSACTION LOGIC & FORM ---
    const [txForm, setTxForm] = useState({
        type: 'deposit', // 'deposit' | 'withdrawal'
        amount: '',
        method: 'transfer', // transfer, cash, card, crypto_buy, crypto_sell, adjustment
        description: ''
    });

    const getMethodLabel = (method) => {
        const labels = {
            transfer: 'Transferencia Bancaria',
            cash: 'Efectivo',
            card: 'Tarjeta Crédito/Débito',
            crypto_buy: 'Compra Crypto',
            crypto_sell: 'Venta Crypto',
            adjustment: 'Ajuste Administrativo'
        };
        return labels[method] || method;
    };

    const handleTransactionSubmit = async () => {
        if (!editingUser) return;
        const amount = parseInt(txForm.amount);
        if (isNaN(amount) || amount <= 0) { alert("Monto inválido"); return; }

        setLoading(true);
        try {
            // 1. Calculate new balance from history (source of truth)
            const currentBal = historyBalance || 0;
            // deposit: Adds to balance. withdrawal: Subtracts.
            const newBal = txForm.type === 'deposit' ? currentBal + amount : currentBal - amount;

            if (newBal < 0) { alert("Error: El saldo no puede ser negativo."); setLoading(false); return; }

            // 2. Update Wallet (Source of Truth)
            const walletRef = doc(db, 'wallets', editingUser.id);
            await setDoc(walletRef, { balances: { CLP: newBal } }, { merge: true });

            // 4. Create Transaction Record
            await addDoc(collection(db, `wallets/${editingUser.id}/history`), {
                type: txForm.type,
                amount: amount,
                balanceAfter: newBal,
                method: txForm.method, // 'transfer', 'cash', etc.
                description: txForm.description || getMethodLabel(txForm.method), // Fallback label
                timestamp: new Date(),
                adminId: auth.currentUser?.email || 'admin'
            });

            // 3. Reset Form
            setTxForm({ type: 'deposit', amount: '', method: 'transfer', description: '' });

            // 4. Refresh History Truth (Immediate Local Update)
            setHistoryBalance(newBal);

            // 5. Background Fetch to sync everything
            await fetchUserHistory(editingUser.id);
            await fetchBatchWalletCLPBalances(); // Refresh table balance

            // 6. NOTIFY USER VIA EMAIL
            try {
                const notificarMov = httpsCallable(functions, 'notificarMovimientoCLP');
                await notificarMov({
                    email: editingUser.email,
                    userId: editingUser.id,
                    type: txForm.type,
                    amount: amount,
                    newBalance: newBal,
                    method: txForm.method
                });
                console.log("✅ Email notification sent successfully.");
            } catch (mailErr) {
                console.error("❌ Failed to send email notification:", mailErr);
                // We don't block the UI if email fails, but we log it.
            }

            setModalStatusMsg(`✅ ¡Movimiento de $${amount.toLocaleString()} registrado con éxito! Correo enviado.`);
            setTimeout(() => setModalStatusMsg(''), 5000); // Clear after 5s

            fetchUsers(); // Refresh list background
        } catch (e) {
            console.error(e);
            alert("Error: " + e.message);
        } finally {
            setLoading(false);
        }
    };


    // REMOVED: handleFixInconsistency - wallets/{uid}/balances.CLP is now source of truth

    const handleSaveUser = async () => {
        if (!editingUser) return;
        setLoading(true);
        try {
            const userRef = doc(db, 'usuarios', editingUser.id);
            await updateDoc(userRef, {
                verificationStatus: editForm.verificationStatus,
                verificationAttempts: parseInt(editForm.verificationAttempts)
            });
            alert("✅ Usuario actualizado correctamente.");
            setEditingUser(null);
            fetchUsers(); // Refresh list
        } catch (e) {
            console.error(e);
            alert("❌ Error al actualizar: " + e.message);
        } finally {
            setLoading(false);
        }
    };



    const handleAdminUnbind = async () => {
        if (!editingUser?.walletAddress) return;
        const confirmUnbind = window.confirm(`¿Seguro que deseas desvincular la wallet ${editingUser.walletAddress} del usuario ${editingUser.email}?`);
        if (!confirmUnbind) return;

        setModalStatusMsg('Desvinculando wallet...');
        try {
            const unbindFn = httpsCallable(functions, 'adminUnbindUserWallet');
            const result = await unbindFn({ userId: editingUser.id });
            if (result.data.success) {
                alert('Wallet desvinculada exitosamente.');
                setEditingUser(null);
                fetchUsers();
            } else {
                alert('Error: ' + result.data.message);
            }
        } catch (error) {
            console.error('Error desvinculando wallet:', error);
            alert('Error al desvincular wallet.');
        } finally {
            setModalStatusMsg('');
        }
    };

    // Abrir modal de comunicación masiva
    const handleAbrirComunicacionModal = () => {
        setShowComunicacionModal(true);
        setComunicacionForm({ tipo: 'anuncio', asunto: '', mensaje: '' });
    };

    // Bloquear/Desbloquear usuario
    const handleToggleBloquearUsuario = async () => {
        if (!editingUser) return;

        const accion = editingUser.bloqueado ? 'desbloquear' : 'bloquear';
        const confirmMsg = editingUser.bloqueado
            ? `¿Desbloquear acceso al usuario ${editingUser.email}?\n\nEl usuario podrá volver a iniciar sesión.`
            : `⚠️ ATENCIÓN: ¿Bloquear acceso al usuario ${editingUser.email}?\n\nEl usuario NO podrá iniciar sesión hasta que sea desbloqueado.\n\n¿Continuar?`;

        if (!window.confirm(confirmMsg)) return;

        setLoading(true);
        setModalStatusMsg(`${accion === 'bloquear' ? 'Bloqueando' : 'Desbloqueando'} usuario...`);

        try {
            const userRef = doc(db, 'usuarios', editingUser.id);
            await updateDoc(userRef, {
                bloqueado: !editingUser.bloqueado,
                bloqueadoAt: !editingUser.bloqueado ? new Date() : null,
                bloqueadoPor: !editingUser.bloqueado ? auth.currentUser?.email : null
            });

            // Actualizar estado local
            setEditingUser({ ...editingUser, bloqueado: !editingUser.bloqueado });
            setEditForm({ ...editForm, bloqueado: !editingUser.bloqueado });

            // Actualizar lista de usuarios
            await fetchUsers();

            alert(`✅ Usuario ${accion === 'bloquear' ? 'bloqueado' : 'desbloqueado'} exitosamente.`);
            setModalStatusMsg(`✅ Usuario ${accion === 'bloquear' ? 'bloqueado' : 'desbloqueado'}`);
        } catch (error) {
            console.error(`Error al ${accion} usuario:`, error);
            alert(`Error al ${accion} usuario: ` + error.message);
            setModalStatusMsg(`❌ Error al ${accion} usuario`);
        } finally {
            setLoading(false);
        }
    };

    // Eliminar usuario completamente
    const handleEliminarUsuario = async () => {
        if (!editingUser) return;

        const email = editingUser.email;
        const confirmStep1 = window.confirm(
            `⚠️⚠️⚠️ ADVERTENCIA CRÍTICA ⚠️⚠️⚠️\n\n` +
            `Estás a punto de ELIMINAR PERMANENTEMENTE al usuario:\n\n` +
            `Email: ${email}\n` +
            `ID: ${editingUser.id}\n\n` +
            `Esta acción es IRREVERSIBLE y eliminará:\n` +
            `• Cuenta de usuario\n` +
            `• Historial de transacciones\n` +
            `• Datos bancarios\n` +
            `• Wallet vinculada\n` +
            `• Todos los registros asociados\n\n` +
            `¿Estás ABSOLUTAMENTE SEGURO?`
        );

        if (!confirmStep1) return;

        // Segunda confirmación con tipeo del email
        const typedEmail = window.prompt(
            `CONFIRMACIÓN FINAL\n\n` +
            `Para confirmar la eliminación, escribe el email del usuario:\n\n` +
            `${email}`
        );

        if (typedEmail !== email) {
            alert('❌ Email incorrecto. Eliminación cancelada.');
            return;
        }

        setLoading(true);
        setModalStatusMsg('Eliminando usuario... Esto puede tardar unos segundos.');

        try {
            const userId = editingUser.id;

            // 1. Eliminar historial de transacciones
            const transactionsRef = collection(db, 'usuarios', userId, 'historial_clp');
            const transactionsSnap = await getDocs(transactionsRef);
            const deleteTransactionsPromises = transactionsSnap.docs.map(doc => deleteDoc(doc.ref));
            await Promise.all(deleteTransactionsPromises);

            // 2. Eliminar wallet si existe
            const walletRef = doc(db, 'wallets', userId);
            const walletSnap = await getDoc(walletRef);
            if (walletSnap.exists()) {
                await deleteDoc(walletRef);
            }

            // 3. Eliminar documento de usuario
            const userRef = doc(db, 'usuarios', userId);
            await deleteDoc(userRef);

            // 4. Actualizar lista local
            await fetchUsers();

            alert(`✅ Usuario ${email} eliminado permanentemente.\n\nTodos los datos asociados han sido borrados.`);
            setEditingUser(null);
            setModalStatusMsg('');
        } catch (error) {
            console.error('Error al eliminar usuario:', error);
            alert('Error al eliminar usuario: ' + error.message);
            setModalStatusMsg('❌ Error al eliminar usuario');
        } finally {
            setLoading(false);
        }
    };

    // Enviar comunicación masiva
    const handleEnviarComunicacionMasiva = async () => {
        const { tipo, asunto, mensaje } = comunicacionForm;

        if (!asunto.trim() || !mensaje.trim()) {
            alert('⚠️ Por favor completa el asunto y el mensaje.');
            return;
        }

        const tipoLabels = {
            'anuncio': 'Anuncio',
            'newsletter': 'Newsletter',
            'promocion': 'Promoción',
            'bienvenida': 'Bienvenida'
        };

        const confirmSend = window.confirm(
            `⚠️ ATENCIÓN: Esta acción enviará un correo a TODOS los usuarios verificados.\n\n` +
            `Tipo: ${tipoLabels[tipo]}\n` +
            `Asunto: ${asunto}\n\n` +
            `¿Estás seguro de continuar?`
        );

        if (!confirmSend) return;

        setStatusMsg(`Enviando ${tipoLabels[tipo].toLowerCase()}... Esto puede tardar varios minutos.`);
        setLoading(true);
        setShowComunicacionModal(false);

        try {
            const enviarComunicacion = httpsCallable(functions, 'enviarComunicacionMasiva');
            const result = await enviarComunicacion({ tipo, asunto, mensaje });

            if (result.data.success) {
                const { totalUsers, successCount, errorCount, errors } = result.data;

                let message = `✅ Proceso completado:\n\n`;
                message += `📊 Total de usuarios: ${totalUsers}\n`;
                message += `✅ Enviados exitosamente: ${successCount}\n`;
                message += `❌ Errores: ${errorCount}\n`;

                if (errors && errors.length > 0) {
                    message += `\n⚠️ Errores detallados:\n`;
                    errors.slice(0, 5).forEach(err => {
                        message += `- ${err.email}: ${err.error}\n`;
                    });
                    if (errors.length > 5) {
                        message += `... y ${errors.length - 5} más\n`;
                    }
                }

                alert(message);
                setStatusMsg(`✅ Correos enviados: ${successCount}/${totalUsers}`);
            } else {
                alert('Error: ' + result.data.message);
                setStatusMsg('❌ Error al enviar correos');
            }
        } catch (error) {
            console.error('Error enviando comunicación:', error);
            alert('Error al enviar correos: ' + error.message);
            setStatusMsg('❌ Error al enviar correos');
        } finally {
            setLoading(false);
        }
    };

    // FILTER USERS
    const filteredUsers = usersList.filter(u => {
        const term = searchTerm.toLowerCase();
        const email = (u.email || '').toLowerCase();
        const address = (u.walletAddress || '').toLowerCase();
        const uid = (u.id || '').toLowerCase();

        return email.includes(term) || address.includes(term) || uid.includes(term);
    });

    // =================================================================================
    // RENDER
    // =================================================================================
    return (
        <div className="content-grid-dashboard">
            <div className="main-column" style={{ gridColumn: '1 / -1' }}> {/* Full Width */}
                <div className="card" style={{ borderColor: '#ffd700', minHeight: '80vh' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px', borderBottom: '1px solid #333', paddingBottom: '15px' }}>
                        <FaUserShield size={24} color="#ffd700" />
                        <h2 style={{ margin: 0 }}>
                            Panel de Administración
                            <span style={{ fontSize: '0.8rem', marginLeft: '10px', color: '#666', fontWeight: 'normal' }}>
                                v{packageJson.version}
                            </span>
                        </h2>

                        {/* TABS HEADER */}
                        <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
                            <button onClick={() => setActiveTab('dashboard')} className={`tab-btn ${activeTab === 'dashboard' ? 'active' : ''}`} style={tabStyle(activeTab === 'dashboard')}>
                                <FaCoins /> Dashboard
                            </button>
                            <button onClick={() => setActiveTab('verificaciones')} className={`tab-btn ${activeTab === 'verificaciones' ? 'active' : ''}`} style={tabStyle(activeTab === 'verificaciones')}>
                                <FaCheckCircle /> Verificaciones ({verifications.length})
                            </button>
                            <button onClick={() => setActiveTab('usuarios')} className={`tab-btn ${activeTab === 'usuarios' ? 'active' : ''}`} style={tabStyle(activeTab === 'usuarios')}>
                                <FaUsers /> Usuarios
                            </button>
                            <button onClick={() => setActiveTab('analytics')} className={`tab-btn ${activeTab === 'analytics' ? 'active' : ''}`} style={tabStyle(activeTab === 'analytics')}>
                                <FaChartLine /> Analytics
                            </button>
                        </div>
                    </div>

                    {/* --- TAB 1: DASHBOARD --- */}
                    {activeTab === 'dashboard' && (
                        <div className="fade-in">
                            {/* BLOCKCHAIN MONITOR WIDGET */}
                            <div style={{ marginBottom: '20px' }}>
                                <BlockchainMonitor />
                            </div>

                            <div className="stats-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                                <div className="stat-box" style={boxStyle}>
                                    <small>Suministro Total</small>
                                    <div style={{ fontSize: '1.5rem', color: '#00d2ff', fontWeight: 'bold' }}>
                                        {isNaN(parseFloat(totalSupply)) ? totalSupply : parseFloat(totalSupply).toLocaleString()} XCO
                                    </div>
                                    {renderContractAddress(XCOIN_ADDR, "Token")}
                                </div>
                                <div className="stat-box" style={boxStyle}>
                                    <small>Bóveda (Owner)</small>
                                    <div style={{ fontSize: '1.5rem', color: '#00bf8f', fontWeight: 'bold' }}>
                                        {isNaN(parseFloat(ownerBalance)) ? ownerBalance : parseFloat(ownerBalance).toLocaleString()} XCO
                                    </div>
                                    {renderContractAddress(ownerAddress, "Wallet")}
                                </div>
                                <div className="stat-box" style={boxStyle}>
                                    <small>Crowdsale Activo</small>
                                    <div style={{ fontSize: '1.5rem', color: '#ffd700', fontWeight: 'bold' }}>
                                        {isNaN(parseFloat(crowdsaleBalance)) ? crowdsaleBalance : parseFloat(crowdsaleBalance).toLocaleString()} XCO
                                    </div>
                                    {renderContractAddress(CROWDSALE_ADDR, "Venta")}
                                </div>
                                <div className="stat-box" style={boxStyle}>
                                    <small>Contrato Staking</small>
                                    <div style={{ fontSize: '1.5rem', color: '#ff9800', fontWeight: 'bold' }}>
                                        {isNaN(parseFloat(stakingBalance)) ? stakingBalance : parseFloat(stakingBalance).toLocaleString()} XCO
                                    </div>
                                    {renderContractAddress(STAKING_ADDR, "Contrato")}
                                    {/* DETAILED BREAKDOWN POPOVER OR INLINE */}
                                    <div style={{ marginTop: '10px', fontSize: '0.8rem', textAlign: 'left', background: 'rgba(0,0,0,0.2)', padding: '5px', borderRadius: '4px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <span>Flexible:</span> <span>{stakingDetail.flexible.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', color: '#aaa' }}>
                                            <span>30 Días:</span> <span>{stakingDetail.locked30.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', color: '#aaa' }}>
                                            <span>90 Días:</span> <span>{stakingDetail.locked90.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', color: '#aaa' }}>
                                            <span>180 Días:</span> <span>{stakingDetail.locked180.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                                        </div>
                                        <div style={{ borderTop: '1px solid #555', marginTop: '3px', paddingTop: '3px', display: 'flex', justifyContent: 'space-between', color: '#4caf50' }}>
                                            <span>Reservas (Pagos):</span> <span>{stakingDetail.reserve.toLocaleString(undefined, { maximumFractionDigits: 0 })}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="stat-box" style={boxStyle}>
                                    <small>Quemados / Irrecuperables</small>
                                    <div style={{ fontSize: '1.5rem', color: '#f44336', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <FaExclamationTriangle size={18} />
                                        {isNaN(parseFloat(burnedBalance)) ? burnedBalance : parseFloat(burnedBalance).toLocaleString()} XCO
                                    </div>
                                    <small style={{ fontSize: '0.7rem', color: '#ff8a80' }}>Contrato Viejo (Sin Acceso)</small>
                                    {renderContractAddress(OLD_CROWDSALE_ADDR, "Lost")}
                                </div>
                                <div className="stat-box" style={boxStyle}>
                                    <small>Circulante (Clientes)</small>
                                    <div style={{ fontSize: '1.5rem', color: '#e0e0e0', fontWeight: 'bold' }}>
                                        {isNaN(parseFloat(circulatingSupply)) ? circulatingSupply : parseFloat(circulatingSupply).toLocaleString()} XCO
                                    </div>
                                </div>
                            </div>

                            {/* LIQUIDITY MANAGER ROW */}
                            <div style={{ marginTop: '20px', display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                {/* MINTING */}
                                <div style={{ flex: 1, minWidth: '300px', background: '#1a1a2e', padding: '20px', borderRadius: '10px', color: '#fff' }}>
                                    <h3><FaHammer /> Emisión de Tokens</h3>
                                    <form onSubmit={handleMint} style={{ display: 'flex', gap: '10px' }}>
                                        <input type="number" placeholder="Cantidad XCO" value={mintAmount} onChange={e => setMintAmount(e.target.value)} style={inputStyle} />
                                        <input type="text" placeholder="Destinatario (Opcional)" value={mintRecipient} onChange={e => setMintRecipient(e.target.value)} style={inputStyle} />
                                        <button type="submit" disabled={loading} style={btnStyle}>{loading ? '...' : 'Crear'}</button>
                                    </form>
                                    {statusMsg && <p style={{ marginTop: '10px', color: statusMsg.includes('Error') || statusMsg.includes('❌') ? 'red' : 'green' }}>{statusMsg}</p>}
                                </div>

                                {/* --- RED DE CAJEROS (ATM NETWORK) --- */}
                                <div style={{ marginTop: '30px', borderTop: '1px solid #333', paddingTop: '20px' }}>
                                    <h3 style={{ color: '#fff', marginBottom: '15px' }}>Red de Cajeros (ATM Network)</h3>

                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '20px' }}>

                                        {/* 1. CAJERO AUTOMÁTICO (USDT <-> XCO) - Rebranded */}
                                        <div style={{ background: '#162447', padding: '20px', borderRadius: '12px', border: '1px solid #00d2ff', boxShadow: '0 4px 15px rgba(0, 210, 255, 0.1)' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '15px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <div style={{ background: 'rgba(0, 210, 255, 0.2)', padding: '8px', borderRadius: '8px' }}>
                                                        <FaRobot size={20} color="#00d2ff" />
                                                    </div>
                                                    <div>
                                                        <h4 style={{ margin: 0, color: '#fff' }}>Liquidez XCO/USDT</h4>
                                                        <small style={{ color: '#00d2ff', fontSize: '0.75rem' }}>Automated Market Maker</small>
                                                        {renderContractAddress(BUYBACK_ADDR, "BuyBack")}
                                                    </div>
                                                </div>
                                                <div style={{ padding: '4px 8px', borderRadius: '4px', background: 'rgba(76, 175, 80, 0.2)', color: '#4caf50', fontSize: '0.7rem', fontWeight: 'bold' }}>ACTIVO</div>
                                            </div>

                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px', background: 'rgba(0,0,0,0.2)', padding: '10px', borderRadius: '8px' }}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <small style={{ color: '#888' }}>Pool USDT</small>
                                                    <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#fff' }}>{parseFloat(buybackUSDT).toLocaleString()}</div>
                                                </div>
                                                <div style={{ textAlign: 'center', borderLeft: '1px solid #444' }}>
                                                    <small style={{ color: '#888' }}>Pool XCO</small>
                                                    <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#fff' }}>{parseFloat(buybackXCO).toLocaleString()}</div>
                                                </div>
                                            </div>

                                            {/* SPREAD DISPLAY */}
                                            <div style={{ marginBottom: '20px', padding: '10px', background: 'rgba(0,0,0,0.4)', borderRadius: '8px', border: '1px solid #444' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                                    <span style={{ fontSize: '0.8rem', color: '#aaa' }}>Precio Venta (ATM):</span>
                                                    <span style={{ fontSize: '0.9rem', color: '#4caf50', fontWeight: 'bold' }}>10.00 USDT</span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                                    <span style={{ fontSize: '0.8rem', color: '#aaa' }}>Precio Compra (Crowdsale):</span>
                                                    <span style={{ fontSize: '0.9rem', color: '#f44336', fontWeight: 'bold' }}>10.00 USDT</span>
                                                </div>
                                                <div style={{ borderTop: '1px solid #555', paddingTop: '5px', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ fontSize: '0.8rem', color: '#fff' }}>Spread (Diferencia):</span>
                                                    <span style={{ fontSize: '0.9rem', color: '#ffd700', fontWeight: 'bold' }}>0.00 USDT (0%)</span>
                                                </div>
                                            </div>

                                            {/* DEPOSIT ACTION */}
                                            <div style={{ marginBottom: '10px', display: 'flex', gap: '5px' }}>
                                                <input
                                                    type="number"
                                                    placeholder="Agregar USDT"
                                                    value={buybackDepositAmount}
                                                    onChange={e => setBuybackDepositAmount(e.target.value)}
                                                    style={{ ...inputStyle, flex: 1, fontSize: '0.8rem', background: '#0f0f1a' }}
                                                />
                                                <button
                                                    onClick={handleDepositBuyback}
                                                    style={{ ...btnStyle, background: '#4caf50', border: 'none', color: '#fff', fontSize: '0.8rem' }}
                                                >
                                                    Depositar
                                                </button>
                                            </div>

                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <button onClick={() => handleWithdrawBuybackAll('USDT')} style={{ ...btnStyle, background: '#1a1a2e', border: '1px solid #f44336', color: '#f44336', flex: 1, fontSize: '0.8rem' }} title="Vaciar Liquidez USDT">
                                                    <FaArrowDown /> Retirar USDT
                                                </button>
                                                <button onClick={() => handleWithdrawBuybackAll('XCO')} style={{ ...btnStyle, background: '#1a1a2e', border: '1px solid #00bf8f', color: '#00bf8f', flex: 1, fontSize: '0.8rem' }} title="Recuperar XCO">
                                                    <FaArrowUp /> Retirar XCO
                                                </button>
                                            </div>
                                        </div>

                                        {/* 2. CAJERO BNB - SISTEMA BIDIRECCIONAL */}
                                        <div style={{ background: '#1a1a2e', padding: '20px', borderRadius: '12px', border: '1px solid #ffd700', boxShadow: '0 4px 15px rgba(255, 215, 0, 0.1)' }}>
                                            {/* HEADER */}
                                            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '5px' }}>
                                                    <FaCoins size={24} color="#ffd700" />
                                                    <h4 style={{ margin: 0, color: '#fff', fontSize: '1.1rem' }}>🏦 CAJERO BNB - SISTEMA BIDIRECCIONAL</h4>
                                                </div>
                                                <small style={{ color: '#aaa', fontSize: '0.75rem' }}>Sistema de Compra/Venta de BNB con Spread Dinámico</small>
                                            </div>

                                            {/* CONFIGURACIÓN DE PRECIOS */}
                                            <div style={{ marginBottom: '20px', padding: '15px', background: 'rgba(0,0,0,0.4)', borderRadius: '8px', border: '1px solid #cfaa00' }}>
                                                <h5 style={{ margin: '0 0 12px 0', color: '#ffd700', fontSize: '0.9rem' }}>📊 CONFIGURACIÓN DE PRECIOS</h5>

                                                {/* Precio Binance */}
                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', padding: '8px', background: 'rgba(255,255,255,0.05)', borderRadius: '4px' }}>
                                                    <span style={{ fontSize: '0.8rem', color: '#aaa' }}>Precio Binance (Referencia):</span>
                                                    <span style={{ fontSize: '0.95rem', color: '#fff', fontWeight: 'bold' }}>{parseFloat(bnbPrice).toFixed(2)} USDT</span>
                                                </div>

                                                {/* Spread Editable */}
                                                <div style={{ margin: '12px 0', padding: '10px', background: 'rgba(255, 215, 0, 0.1)', borderRadius: '6px', border: '1px solid #ffd700' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                                                        <span style={{ fontSize: '0.8rem', color: '#ffd700', fontWeight: 'bold' }}>Spread (Comisión):</span>
                                                        {editingBnbSpread ? (
                                                            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                                <input
                                                                    type="number"
                                                                    value={tempBnbSpread}
                                                                    onChange={(e) => setTempBnbSpread(parseFloat(e.target.value))}
                                                                    step="0.1"
                                                                    min="0"
                                                                    max="100"
                                                                    style={{ width: '60px', padding: '4px', borderRadius: '4px', border: '1px solid #ffd700', background: '#0f0f1a', color: '#fff', fontSize: '0.8rem', textAlign: 'center' }}
                                                                />
                                                                <span style={{ fontSize: '0.8rem', color: '#ffd700' }}>%</span>
                                                                <button onClick={handleSaveBnbSpread} style={{ padding: '4px 8px', background: '#4caf50', border: 'none', borderRadius: '4px', color: '#fff', cursor: 'pointer', fontSize: '0.7rem', display: 'flex', alignItems: 'center', gap: '3px' }}>
                                                                    <FaSave /> Guardar
                                                                </button>
                                                                <button onClick={() => { setEditingBnbSpread(false); setTempBnbSpread(bnbSpreadVenta); }} style={{ padding: '4px 8px', background: '#f44336', border: 'none', borderRadius: '4px', color: '#fff', cursor: 'pointer', fontSize: '0.7rem' }}>
                                                                    <FaTimes />
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '1rem', color: '#ffd700', fontWeight: 'bold' }}>{bnbSpreadVenta.toFixed(2)}%</span>
                                                                <button onClick={() => { setEditingBnbSpread(true); setTempBnbSpread(bnbSpreadVenta); }} style={{ padding: '4px 8px', background: 'transparent', border: '1px solid #ffd700', borderRadius: '4px', color: '#ffd700', cursor: 'pointer', fontSize: '0.7rem', display: 'flex', alignItems: 'center', gap: '3px' }}>
                                                                    <FaCog /> Editar
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <small style={{ fontSize: '0.7rem', color: '#aaa', fontStyle: 'italic' }}>
                                                        Este spread se aplica a compra y venta
                                                    </small>
                                                </div>

                                                {/* Precios Calculados */}
                                                <div style={{ display: 'grid', gap: '8px' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', background: 'rgba(76, 175, 80, 0.1)', borderRadius: '4px', border: '1px solid #4caf50' }}>
                                                        <span style={{ fontSize: '0.8rem', color: '#4caf50' }}>💰 Precio Venta (ATM → Usuario):</span>
                                                        <span style={{ fontSize: '0.95rem', color: '#4caf50', fontWeight: 'bold' }}>
                                                            {(parseFloat(bnbPrice) * (1 + bnbSpreadVenta / 100)).toFixed(2)} USDT
                                                        </span>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', background: 'rgba(255, 152, 0, 0.1)', borderRadius: '4px', border: '1px solid #ff9800' }}>
                                                        <span style={{ fontSize: '0.8rem', color: '#ff9800' }}>💸 Precio Compra (Usuario → ATM):</span>
                                                        <span style={{ fontSize: '0.95rem', color: '#ff9800', fontWeight: 'bold' }}>
                                                            {(parseFloat(bnbPrice) * (1 - bnbSpreadCompra / 100)).toFixed(2)} USDT
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* CONTRATO UNIFICADO BNB */}
                                            <div style={{ marginBottom: '15px', padding: '15px', background: 'rgba(76, 175, 80, 0.05)', borderRadius: '8px', border: '1px solid #4caf50' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                                                    <h5 style={{ margin: 0, color: '#4caf50', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        💰 CONTRATO UNIFICADO BNB (Compra/Venta)
                                                    </h5>
                                                    <div style={{ padding: '3px 8px', borderRadius: '4px', background: parseFloat(bnbAtmBalance) < 0.1 ? 'rgba(244, 67, 54, 0.2)' : 'rgba(76, 175, 80, 0.2)', color: parseFloat(bnbAtmBalance) < 0.1 ? '#f44336' : '#4caf50', fontSize: '0.65rem', fontWeight: 'bold' }}>
                                                        {parseFloat(bnbAtmBalance) < 0.1 ? '🔴 LOW LIQUIDITY' : '🟢 ONLINE'}
                                                    </div>
                                                </div>
                                                <small style={{ color: '#aaa', fontSize: '0.7rem', display: 'block', marginBottom: '10px' }}>Usuario compra BNB con USDT o vende BNB por USDT</small>
                                                {renderContractAddress(BNB_EXCHANGE_ADDR, "Unificado")}

                                                {/* Balance y Historial */}
                                                <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                                                    <div style={{ padding: '10px', background: 'rgba(0,0,0,0.3)', borderRadius: '6px', marginBottom: '10px' }}>
                                                        <small style={{ color: '#aaa', fontSize: '0.7rem' }}>BNB Disponible:</small>
                                                        <div style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#4caf50' }}>
                                                            {parseFloat(bnbAtmBalance).toLocaleString(undefined, { maximumFractionDigits: 4 })} BNB
                                                        </div>
                                                    </div>
                                                    <button
                                                        onClick={() => { setShowHistorialVenta(true); fetchHistorialVenta(); }}
                                                        style={{
                                                            width: '100%',
                                                            padding: '10px',
                                                            background: 'rgba(76, 175, 80, 0.1)',
                                                            border: '1px solid #4caf50',
                                                            borderRadius: '6px',
                                                            color: '#4caf50',
                                                            cursor: 'pointer',
                                                            fontSize: '0.8rem',
                                                            fontWeight: 'bold',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '8px'
                                                        }}
                                                    >
                                                        📊 Ver Historial de BNB
                                                    </button>
                                                </div>

                                                {/* Gestión de Liquidez BNB */}
                                                <div style={{ fontSize: '0.75rem', color: '#aaa', marginBottom: '8px' }}>Gestión de Liquidez BNB:</div>
                                                <div style={{ display: 'grid', gap: '8px' }}>
                                                    <div style={{ display: 'flex', gap: '5px' }}>
                                                        <input
                                                            type="number"
                                                            placeholder="BNB a Depositar"
                                                            value={atmRefillAmount}
                                                            onChange={e => setAtmRefillAmount(e.target.value)}
                                                            style={{ ...inputStyle, flex: 1, fontSize: '0.8rem', background: '#0f0f1a' }}
                                                        />
                                                        <button onClick={handleRefillBNB} style={{ ...btnStyle, background: '#4caf50', fontSize: '0.8rem', width: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                            <FaArrowUp size={12} /> Depositar
                                                        </button>
                                                    </div>
                                                    <div style={{ display: 'flex', gap: '5px' }}>
                                                        <input
                                                            type="number"
                                                            placeholder="BNB a Retirar"
                                                            value={atmWithdrawAmount}
                                                            onChange={e => setAtmWithdrawAmount(e.target.value)}
                                                            style={{ ...inputStyle, flex: 1, fontSize: '0.8rem', background: '#0f0f1a' }}
                                                        />
                                                        <button onClick={handleWithdrawBNB} style={{ ...btnStyle, background: '#f44336', fontSize: '0.8rem', width: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                            <FaArrowDown size={12} /> Retirar
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* LIQUIDEZ USDT DEL CONTRATO UNIFICADO */}
                                            <div style={{ padding: '15px', background: 'rgba(255, 152, 0, 0.05)', borderRadius: '8px', border: '1px solid #ff9800' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                                                    <h5 style={{ margin: 0, color: '#ff9800', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        💸 LIQUIDEZ USDT (Mismo Contrato)
                                                    </h5>
                                                    <div style={{ padding: '3px 8px', borderRadius: '4px', background: parseFloat(bnbBuybackUSDT) < 10 ? 'rgba(244, 67, 54, 0.2)' : 'rgba(76, 175, 80, 0.2)', color: parseFloat(bnbBuybackUSDT) < 10 ? '#f44336' : '#4caf50', fontSize: '0.65rem', fontWeight: 'bold' }}>
                                                        {parseFloat(bnbBuybackUSDT) < 10 ? '🔴 LOW LIQUIDITY' : '🟢 ONLINE'}
                                                    </div>
                                                </div>
                                                <small style={{ color: '#aaa', fontSize: '0.7rem', display: 'block', marginBottom: '10px' }}>Liquidez USDT del contrato unificado</small>
                                                {renderContractAddress(BNB_EXCHANGE_ADDR, "Unificado")}

                                                {/* Balance y Historial */}
                                                <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                                                    <div style={{ padding: '10px', background: 'rgba(0,0,0,0.3)', borderRadius: '6px', marginBottom: '10px' }}>
                                                        <small style={{ color: '#aaa', fontSize: '0.7rem' }}>USDT Disponible:</small>
                                                        <div style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#ff9800' }}>
                                                            {parseFloat(bnbBuybackUSDT).toLocaleString(undefined, { maximumFractionDigits: 2 })} USDT
                                                        </div>
                                                    </div>
                                                    <button
                                                        onClick={() => { setShowHistorialCompra(true); fetchHistorialCompra(); }}
                                                        style={{
                                                            width: '100%',
                                                            padding: '10px',
                                                            background: 'rgba(255, 152, 0, 0.1)',
                                                            border: '1px solid #ff9800',
                                                            borderRadius: '6px',
                                                            color: '#ff9800',
                                                            cursor: 'pointer',
                                                            fontSize: '0.8rem',
                                                            fontWeight: 'bold',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '8px'
                                                        }}
                                                    >
                                                        📊 Ver Historial de USDT
                                                    </button>
                                                </div>

                                                {/* Gestión de Liquidez USDT */}
                                                <div style={{ fontSize: '0.75rem', color: '#aaa', marginBottom: '8px' }}>Gestión de Liquidez USDT:</div>
                                                <div style={{ display: 'grid', gap: '8px' }}>
                                                    <div style={{ display: 'flex', gap: '5px' }}>
                                                        <input
                                                            type="number"
                                                            placeholder="Cantidad de USDT a Depositar"
                                                            value={buybackDepositUSDT}
                                                            onChange={e => setBuybackDepositUSDT(e.target.value)}
                                                            style={{ ...inputStyle, flex: 1, fontSize: '0.8rem', background: '#0f0f1a' }}
                                                        />
                                                        <button
                                                            onClick={handleDepositBnbBuyback}
                                                            disabled={loading}
                                                            style={{ ...btnStyle, background: '#4caf50', fontSize: '0.8rem', width: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}
                                                        >
                                                            <FaArrowUp size={12} /> Depositar
                                                        </button>
                                                    </div>
                                                    <div style={{ display: 'flex', gap: '5px' }}>
                                                        <input
                                                            type="number"
                                                            placeholder="Cantidad de USDT a Retirar"
                                                            value={buybackWithdrawUSDT}
                                                            onChange={e => setBuybackWithdrawUSDT(e.target.value)}
                                                            style={{ ...inputStyle, flex: 1, fontSize: '0.8rem', background: '#0f0f1a' }}
                                                        />
                                                        <button
                                                            onClick={handleWithdrawUSDT}
                                                            disabled={loading}
                                                            style={{ ...btnStyle, background: '#f44336', fontSize: '0.8rem', width: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}
                                                        >
                                                            <FaArrowDown size={12} /> Retirar
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    )}

                    {/* --- TAB 2: VERIFICACIONES --- */}
                    {activeTab === 'verificaciones' && (
                        <div className="fade-in">
                            <h3>Solicitudes Pendientes</h3>
                            {verifications.length === 0 ? <p style={{ opacity: 0.6 }}>No hay solicitudes pendientes.</p> : (
                                <table className="admin-table" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px', color: '#eee' }}>
                                    {/* Table contents same as previous */}
                                    <thead>
                                        <tr style={{ borderBottom: '1px solid #444', textAlign: 'left' }}>
                                            <th style={{ padding: '10px' }}>Usuario</th>
                                            <th style={{ padding: '10px' }}>Banco</th>
                                            <th style={{ padding: '10px' }}>Monto</th>
                                            <th style={{ padding: '10px' }}>Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {verifications.map(req => (
                                            <tr key={req.id} style={{ borderBottom: '1px solid #222' }}>
                                                <td style={{ padding: '10px' }}>{req.email}</td>
                                                <td style={{ padding: '10px' }}>{req.bankAccount?.bankName}</td>
                                                <td style={{ padding: '10px' }}>{req.depositAmount || '-'}</td>
                                                <td style={{ padding: '10px' }}>
                                                    {selectedRequest?.id === req.id ? (
                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                            <input
                                                                type="number"
                                                                placeholder="Monto CLP"
                                                                value={depositAmount}
                                                                onChange={e => setDepositAmount(e.target.value)}
                                                                style={{ width: '80px', padding: '5px', borderRadius: '4px' }}
                                                                autoFocus
                                                            />
                                                            <button onClick={() => handleConfirmDeposit(req)} style={{ background: '#4caf50', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5px 10px' }}><FaCheck color="white" /></button>
                                                            <button onClick={() => setSelectedRequest(null)} style={{ background: '#dc3545', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5px 10px' }}><FaTimes color="white" /></button>
                                                        </div>
                                                    ) : (
                                                        <button
                                                            onClick={() => { setSelectedRequest(req); setDepositAmount(''); }}
                                                            style={{ background: '#00d2ff', color: 'black', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                                                        >
                                                            Confirmar
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}

                    {/* --- TAB 3: USUARIOS --- */}
                    {activeTab === 'usuarios' && (
                        <div className="fade-in">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                                <h3>Base de Usuarios ({usersList.length})</h3>
                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                    <button
                                        onClick={handleAbrirComunicacionModal}
                                        disabled={loading}
                                        style={{
                                            padding: '10px 20px',
                                            borderRadius: '5px',
                                            border: 'none',
                                            background: loading ? '#666' : 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            cursor: loading ? 'not-allowed' : 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            fontSize: '0.9rem'
                                        }}
                                    >
                                        📢 Comunicación Masiva
                                    </button>
                                    <div style={{ position: 'relative' }}>
                                        <FaSearch style={{ position: 'absolute', left: '10px', top: '10px', color: '#666' }} />
                                        <input
                                            type="text"
                                            placeholder="Buscar por email..."
                                            value={searchTerm}
                                            onChange={e => setSearchTerm(e.target.value)}
                                            style={{ ...inputStyle, paddingLeft: '30px' }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ background: '#1a1a2e', padding: '15px', borderRadius: '10px', marginTop: '15px' }}>
                                <table className="admin-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem', color: '#eee' }}>
                                    {/* Table contents same as previous */}
                                    <thead>
                                        <tr style={{ borderBottom: '1px solid #444', textAlign: 'left' }}>
                                            <th style={{ padding: '10px' }}>Email / ID</th>
                                            <th style={{ padding: '10px' }}>Estado</th>
                                            <th style={{ padding: '10px' }}>Wallet</th>
                                            <th style={{ padding: '10px' }}>Ref (Tot)</th>
                                            <th style={{ padding: '10px', color: '#ff9800' }}>Patrimonio XCO</th>
                                            <th style={{ padding: '10px', color: '#4caf50' }}>Saldo CLP</th>
                                            <th style={{ padding: '10px' }}>Config</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredUsers.map(u => (
                                            <tr key={u.id} style={{ borderBottom: '1px solid #222', cursor: 'pointer', background: editingUser?.id === u.id ? '#333' : 'transparent' }} onClick={() => handleEditUser(u)}>
                                                <td style={{ padding: '10px' }}>
                                                    <div>{u.email}</div>
                                                    <small style={{ opacity: 0.5 }}>{u.id.substring(0, 8)}...</small>
                                                </td>
                                                <td style={{ padding: '10px' }}>
                                                    <span style={getStatusStyle(u.verificationStatus)}>{u.verificationStatus || 'unverified'}</span>
                                                </td>
                                                <td style={{ padding: '10px' }}>
                                                    {u.walletAddress ?
                                                        <span style={{ color: '#4caf50', fontFamily: 'monospace' }}>{u.walletAddress.substring(0, 6)}...</span>
                                                        : <span style={{ opacity: 0.3 }}>Sin vincular</span>
                                                    }
                                                </td>
                                                <td style={{ padding: '10px', textAlign: 'center' }}>
                                                    {u.walletAddress && referralCounts[u.walletAddress.toLowerCase()] ?
                                                        <span style={{ background: '#2196f3', color: 'white', borderRadius: '10px', padding: '2px 8px', fontSize: '0.8rem' }}>
                                                            {referralCounts[u.walletAddress.toLowerCase()]}
                                                        </span>
                                                        : <span style={{ opacity: 0.3 }}>-</span>
                                                    }
                                                </td>
                                                <td style={{ padding: '10px', color: '#ff9800', fontWeight: 'bold' }}>
                                                    {userChainData[u.id] ?
                                                        parseFloat(userChainData[u.id].total).toLocaleString() + ' XCO'
                                                        : u.walletAddress ? '...' : '-'}
                                                </td>
                                                <td style={{ padding: '10px', color: '#4caf50' }}>
                                                    {userWalletCLPBalances[u.id] !== undefined ?
                                                        `$${userWalletCLPBalances[u.id].toLocaleString()}`
                                                        : '...'}
                                                </td>
                                                <td style={{ padding: '10px' }}>
                                                    <button onClick={(e) => { e.stopPropagation(); handleEditUser(u); }} style={{ background: 'transparent', border: '1px solid #666', color: '#aaa', cursor: 'pointer', borderRadius: '4px', padding: '5px', display: 'flex', alignItems: 'center' }}><FaCog /></button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* --- TAB 4: ANALYTICS --- */}
                    {activeTab === 'analytics' && <AnalyticsTab />}

                </div>
            </div>

            {/* --- MODAL EDIT USER --- */}
            {
                editingUser && (
                    <div style={modalOverlayStyle}>
                        <div style={modalContentStyle}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid #444', paddingBottom: '10px' }}>
                                <h2>
                                    <FaUserShield /> Administrar Usuario
                                    <span style={{ fontSize: '0.8rem', marginLeft: '10px', color: '#666', fontWeight: 'normal' }}>v{packageJson.version}</span>
                                </h2>
                                <button onClick={() => setEditingUser(null)} style={{ background: 'transparent', border: 'none', color: 'white', fontSize: '1.2rem', cursor: 'pointer' }}><FaTimes /></button>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                {/* Columna 1: Info General */}
                                <div>
                                    <h4 style={{ color: '#ffd700' }}>Información Básica</h4>
                                    <div style={infoRowStyle}><label>ID:</label> <span>{editingUser.id}</span></div>
                                    <div style={infoRowStyle}><label>Email:</label> <span>{editingUser.email}</span></div>
                                    <div style={infoRowStyle}>
                                        <label>Wallet:</label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <span style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>{editingUser.walletAddress || 'No vinculada'}</span>
                                            {editingUser.walletAddress && (
                                                <button onClick={handleAdminUnbind} style={{ background: '#ff4444', border: 'none', color: 'white', cursor: 'pointer', padding: '2px 6px', borderRadius: '4px', fontSize: '0.7rem' }}>Desvincular</button>
                                            )}
                                        </div>
                                    </div>

                                    <h4 style={{ marginTop: '20px', color: '#ffd700' }}>Datos Bancarios</h4>
                                    {editingUser.bankAccount ? (
                                        <div style={{ background: '#1a1a2e', padding: '10px', borderRadius: '5px', fontSize: '0.9rem', color: '#ccc' }}>
                                            <div><strong style={{ color: '#fff' }}>Banco:</strong> {editingUser.bankAccount.bankName}</div>
                                            <div><strong style={{ color: '#fff' }}>Tipo:</strong> {editingUser.bankAccount.accountType}</div>
                                            <div><strong style={{ color: '#fff' }}>N°:</strong> {editingUser.bankAccount.accountNumber}</div>
                                            <div><strong style={{ color: '#fff' }}>RUT:</strong> {editingUser.bankAccount.rut}</div>
                                        </div>
                                    ) : <p style={{ opacity: 0.5 }}>No ha registrado datos bancarios.</p>}

                                    {/* --- RED DE REFERIDOS (Nuevo Bloque) --- */}
                                    <div style={{ marginTop: '20px', borderTop: '1px solid #444', paddingTop: '15px' }}>
                                        <h4 style={{ color: '#00d2ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <FaUsers /> Red de Referidos (Embudo)
                                        </h4>

                                        {referralDetails.loading ? (
                                            <p style={{ fontStyle: 'italic', opacity: 0.7 }}>Cargando referidos...</p>
                                        ) : referralDetails.list.length === 0 ? (
                                            <p style={{ opacity: 0.5 }}>No se encontraron referidos.</p>
                                        ) : (
                                            <>
                                                <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                                    <span style={{ fontSize: '0.8rem', background: '#333', padding: '2px 8px', borderRadius: '10px', color: '#aaa' }}>Invitados: {referralDetails.stats.invited}</span>
                                                    <span style={{ fontSize: '0.8rem', background: '#2196f3', padding: '2px 8px', borderRadius: '10px', color: '#fff' }}>Registrados: {referralDetails.stats.registered}</span>
                                                    <span style={{ fontSize: '0.8rem', background: '#ff9800', padding: '2px 8px', borderRadius: '10px', color: '#000' }}>Inversionistas: {referralDetails.stats.investors}</span>
                                                </div>

                                                <div style={{ maxHeight: '150px', overflowY: 'auto', background: '#222', padding: '5px', borderRadius: '5px' }}>
                                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                                                        <thead>
                                                            <tr style={{ textAlign: 'left', color: '#888', borderBottom: '1px solid #444' }}>
                                                                <th style={{ padding: '5px' }}>Email</th>
                                                                <th style={{ padding: '5px' }}>Estado</th>
                                                                <th style={{ padding: '5px' }}>Wallet</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {referralDetails.list.map((ref, idx) => (
                                                                <tr key={idx} style={{ borderBottom: '1px solid #333' }}>
                                                                    <td style={{ padding: '5px', color: '#ddd' }}>{ref.email}</td>
                                                                    <td style={{ padding: '5px' }}>
                                                                        {ref.status === 'Inversionista' && <span style={{ color: '#ff9800', fontWeight: 'bold' }}><FaCoins /> Inv.</span>}
                                                                        {ref.status === 'Registrado' && <span style={{ color: '#2196f3' }}><FaCheckCircle /> Reg.</span>}
                                                                        {ref.status === 'Invitado' && <span style={{ color: '#aaa' }}>Invitado</span>}
                                                                    </td>
                                                                    <td style={{ padding: '5px', fontFamily: 'monospace', color: '#888' }}>
                                                                        {ref.wallet ? ref.wallet.substring(0, 6) + '...' : '-'}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    {/* --- PLANIFICACIÓN DE LIQUIDEZ (STAKING LOCKED) --- */}
                                    <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '15px' }}>
                                        <h4 style={{ color: '#ff9800', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <FaClock /> Planificación de Liquidez
                                        </h4>
                                        <p style={{ fontSize: '0.8rem', color: '#aaa', marginBottom: '10px' }}>
                                            Depósitos a Plazo Fijo (Locked Staking) y sus fechas de liberación.
                                        </p>

                                        {modalLockedDetails.loading ? (
                                            <p style={{ fontStyle: 'italic', opacity: 0.7 }}>Cargando datos on-chain...</p>
                                        ) : modalLockedDetails.deposits.length === 0 ? (
                                            <div style={{ background: '#222', padding: '10px', borderRadius: '5px', textAlign: 'center', opacity: 0.6 }}>
                                                Sin depósitos bloqueados activos.
                                            </div>
                                        ) : (
                                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                                                <thead>
                                                    <tr style={{ textAlign: 'left', borderBottom: '1px solid #555', color: '#888' }}>
                                                        <th style={{ padding: '5px' }}>Monto (XCO)</th>
                                                        <th style={{ padding: '5px' }}>Plazo</th>
                                                        <th style={{ padding: '5px' }}>Libera el</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {modalLockedDetails.deposits.map((dep, idx) => (
                                                        <tr key={idx} style={{ borderBottom: '1px solid #333' }}>
                                                            <td style={{ padding: '5px', fontWeight: 'bold', color: '#fff' }}>
                                                                {parseFloat(dep.amount).toLocaleString()}
                                                            </td>
                                                            <td style={{ padding: '5px' }}>
                                                                {dep.period === 0 ? '30d' : dep.period === 1 ? '90d' : '180d'}
                                                            </td>
                                                            <td style={{ padding: '5px', color: dep.isUnlocked ? '#4caf50' : '#f44336' }}>
                                                                {dep.unlockDate} {dep.isUnlocked ? '(Libre)' : ''}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>

                                </div>

                                {/* Columna 2: Edición y Saldos */}
                                <div>
                                    <h4 style={{ color: '#00d2ff' }}>Saldos y Estado</h4>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px' }}>
                                            Saldo CLP (Fuente Cliente: 'wallets')
                                        </label>
                                        <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                            <input
                                                type="text"
                                                value={walletRealBalance !== null ? `$${walletRealBalance.toLocaleString()}` : "Cargando..."}
                                                disabled={true}
                                                style={{ ...inputStyle, color: '#4caf50', fontWeight: 'bold' }}
                                            />
                                        </div>
                                        <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '5px' }}>
                                            Historial Calculado: ${historyBalance.toLocaleString()}
                                            {walletRealBalance !== null && walletRealBalance !== historyBalance && (
                                                <span style={{ color: '#ff9800', marginLeft: '10px' }}>
                                                    (Difiere en ${Math.abs(walletRealBalance - historyBalance).toLocaleString()})
                                                </span>
                                            )}
                                        </div>



                                        <div style={{ marginTop: '15px', background: '#333', padding: '10px', borderRadius: '5px', border: '1px solid #555' }}>
                                            <h5 style={{ margin: '0 0 10px 0', color: '#eee' }}>Registrar Transacción</h5>

                                            <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                                <select
                                                    value={txForm.type}
                                                    onChange={e => setTxForm({ ...txForm, type: e.target.value })}
                                                    style={{ ...inputStyle, flex: 1, borderColor: txForm.type === 'deposit' ? '#4caf50' : '#f44336' }}
                                                >
                                                    <option value="deposit">Ingresar Fondos (+)</option>
                                                    <option value="withdrawal">Retirar Fondos (-)</option>
                                                </select>
                                                <input
                                                    type="number"
                                                    placeholder="Monto"
                                                    value={txForm.amount}
                                                    onChange={e => setTxForm({ ...txForm, amount: e.target.value })}
                                                    style={{ ...inputStyle, flex: 1 }}
                                                />
                                            </div>

                                            <div style={{ marginBottom: '10px' }}>
                                                <select
                                                    value={txForm.method}
                                                    onChange={e => setTxForm({ ...txForm, method: e.target.value })}
                                                    style={inputStyle}
                                                >
                                                    <option value="transfer">Transferencia Bancaria</option>
                                                    <option value="cash">Efectivo</option>
                                                    <option value="card">Tarjeta / Débito</option>
                                                    <option value="crypto_sell">Venta Crypto (Aumenta CLP)</option>
                                                    <option value="crypto_buy">Compra Crypto (Descuenta CLP)</option>
                                                    <option value="adjustment">Ajuste / Corrección</option>
                                                </select>
                                            </div>

                                            <button onClick={handleTransactionSubmit} disabled={loading} style={{ ...btnStyle, width: '100%', background: txForm.type === 'deposit' ? '#4caf50' : '#f44336', color: 'white' }}>
                                                {loading ? 'Procesando...' : (txForm.type === 'deposit' ? 'Confirmar INGRESO' : 'Confirmar RETIRO')}
                                            </button>
                                            {modalStatusMsg && (
                                                <div style={{ marginTop: '10px', padding: '8px', background: modalStatusMsg.includes('✅') ? 'rgba(76, 175, 80, 0.2)' : 'rgba(244, 67, 54, 0.2)', border: `1px solid ${modalStatusMsg.includes('✅') ? '#4caf50' : '#f44336'}`, borderRadius: '5px', color: modalStatusMsg.includes('✅') ? '#81c784' : '#e57373', textAlign: 'center', fontSize: '0.85rem' }}>
                                                    {modalStatusMsg}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px' }}>Patrimonio XCoin Total (Wallet + Staking)</label>
                                        <div style={{ padding: '10px', background: '#222', borderRadius: '5px', color: '#00d2ff', display: 'flex', alignItems: 'center', gap: '10px', border: '1px solid #00d2ff' }}>
                                            <FaCoins />
                                            <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                                                {userChainData[editingUser.id] ? parseFloat(userChainData[editingUser.id].total).toLocaleString() : '...'} XCO
                                            </span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', padding: '5px', opacity: 0.8 }}>
                                            <span>Wallet: {userChainData[editingUser.id] ? parseFloat(userChainData[editingUser.id].wallet).toLocaleString() : '-'}</span>
                                            <span>Flexible: {userChainData[editingUser.id] ? parseFloat(userChainData[editingUser.id].flexible).toLocaleString() : '-'}</span>
                                            <span>Locked: {userChainData[editingUser.id] ? parseFloat(userChainData[editingUser.id].locked).toLocaleString() : '-'}</span>
                                        </div>
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px' }}>Estado de Verificación</label>
                                        <select
                                            value={editForm.verificationStatus}
                                            onChange={e => setEditForm({ ...editForm, verificationStatus: e.target.value })}
                                            style={inputStyle}
                                        >
                                            <option value="unverified">No Verificado</option>
                                            <option value="pending">Pendiente (Solicitado)</option>
                                            <option value="verified">Verificado</option>
                                        </select>
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px' }}>Intentos Fallidos</label>
                                        <input
                                            type="number"
                                            value={editForm.verificationAttempts}
                                            onChange={e => setEditForm({ ...editForm, verificationAttempts: e.target.value })}
                                            style={inputStyle}
                                        >

                                        </input>
                                    </div>

                                    <button onClick={handleSaveUser} disabled={loading} style={{ ...btnStyle, width: '100%', marginTop: '10px', background: '#4caf50', color: 'white' }}>
                                        {loading ? 'Guardando...' : <><FaSave /> Guardar Cambios</>}
                                    </button>

                                    {/* ZONA DE PELIGRO */}
                                    <div style={{ marginTop: '30px', borderTop: '2px solid #ff4444', paddingTop: '20px' }}>
                                        <h4 style={{ color: '#ff4444', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <FaExclamationTriangle /> Zona de Peligro
                                        </h4>
                                        <p style={{ fontSize: '0.85rem', color: '#aaa', marginBottom: '15px' }}>
                                            Acciones críticas que afectan el acceso y los datos del usuario.
                                        </p>

                                        {/* Botón Bloquear/Desbloquear */}
                                        <button
                                            onClick={handleToggleBloquearUsuario}
                                            disabled={loading}
                                            style={{
                                                ...btnStyle,
                                                width: '100%',
                                                marginBottom: '10px',
                                                background: loading ? '#666' : (editingUser?.bloqueado ? '#ff9800' : '#ff5722'),
                                                color: 'white',
                                                border: 'none'
                                            }}
                                        >
                                            {loading ? 'Procesando...' : (
                                                editingUser?.bloqueado
                                                    ? '🔓 Desbloquear Acceso'
                                                    : '🔒 Bloquear Acceso'
                                            )}
                                        </button>

                                        {editingUser?.bloqueado && (
                                            <div style={{
                                                background: 'rgba(255, 152, 0, 0.1)',
                                                border: '1px solid #ff9800',
                                                borderRadius: '5px',
                                                padding: '10px',
                                                marginBottom: '10px',
                                                fontSize: '0.85rem',
                                                color: '#ff9800'
                                            }}>
                                                🔒 <strong>Usuario bloqueado</strong> - No puede iniciar sesión
                                            </div>
                                        )}

                                        {/* Botón Eliminar */}
                                        <button
                                            onClick={handleEliminarUsuario}
                                            disabled={loading}
                                            style={{
                                                ...btnStyle,
                                                width: '100%',
                                                background: loading ? '#666' : '#d32f2f',
                                                color: 'white',
                                                border: 'none'
                                            }}
                                        >
                                            {loading ? 'Procesando...' : '🗑️ Eliminar Usuario Permanentemente'}
                                        </button>

                                        <p style={{ fontSize: '0.75rem', color: '#666', marginTop: '10px', fontStyle: 'italic' }}>
                                            ⚠️ La eliminación es irreversible y borra todos los datos del usuario.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* --- HISTORY TABLE (ADMIN VIEW) --- */}
                            <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '20px' }}>
                                <h4 style={{ color: '#aaa', margin: '0 0 15px 0' }}>Historial de Transacciones (Auditoría)</h4>
                                {userTransactions.length === 0 ? <p style={{ opacity: 0.5 }}>No hay historial registrado.</p> : (
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
                                        <thead>
                                            <tr style={{ textAlign: 'left', color: '#888', borderBottom: '1px solid #444' }}>
                                                <th style={{ padding: '5px' }}>Fecha</th>
                                                <th style={{ padding: '5px' }}>Tipo</th>
                                                <th style={{ padding: '5px' }}>Método / Detalle</th>
                                                <th style={{ padding: '5px' }}>Monto</th>
                                                <th style={{ padding: '5px' }}>Saldo Resultante</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userTransactions.map(tx => (
                                                <tr key={tx.id} style={{ borderBottom: '1px solid #333' }}>
                                                    <td style={{ padding: '5px', color: '#ccc' }}>{tx.timestamp?.toDate ? tx.timestamp.toDate().toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'Reciente'}</td>
                                                    <td style={{ padding: '5px', color: tx.type === 'deposit' ? '#4caf50' : '#f44336' }}>{tx.type === 'deposit' ? 'INGRESO' : 'RETIRO'}</td>
                                                    <td style={{ padding: '5px' }}>{tx.description || tx.method}</td>
                                                    <td style={{ padding: '5px' }}>${parseInt(tx.amount).toLocaleString()}</td>
                                                    <td style={{ padding: '5px', fontWeight: 'bold', color: '#ffd700' }}>${(tx.resultingBalance !== undefined ? tx.resultingBalance : (tx.computedBalance || 0)).toLocaleString()}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                        </div>
                    </div>
                )
            }

            {/* MODAL: COMUNICACIÓN MASIVA */}
            {showComunicacionModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.8)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10000
                }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                        padding: '30px',
                        borderRadius: '15px',
                        width: '90%',
                        maxWidth: '600px',
                        maxHeight: '90vh',
                        overflow: 'auto',
                        boxShadow: '0 10px 40px rgba(0,0,0,0.5)'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h2 style={{ color: '#ffd700', margin: 0 }}>📢 Comunicación Masiva</h2>
                            <button
                                onClick={() => setShowComunicacionModal(false)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: '#fff',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    padding: '5px 10px'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', color: '#ddd', marginBottom: '8px', fontWeight: 'bold' }}>
                                Tipo de Mensaje
                            </label>
                            <select
                                value={comunicacionForm.tipo}
                                onChange={(e) => setComunicacionForm({ ...comunicacionForm, tipo: e.target.value })}
                                style={{
                                    ...inputStyle,
                                    cursor: 'pointer',
                                    fontSize: '16px'
                                }}
                            >
                                <option value="anuncio">📢 Anuncio General</option>
                                <option value="newsletter">📰 Newsletter</option>
                                <option value="promocion">🎉 Promoción</option>
                                <option value="bienvenida">👋 Bienvenida</option>
                            </select>
                            <p style={{ fontSize: '12px', color: '#999', marginTop: '5px' }}>
                                {comunicacionForm.tipo === 'anuncio' && '📢 Ideal para avisos importantes y actualizaciones del sistema'}
                                {comunicacionForm.tipo === 'newsletter' && '📰 Perfecto para reportes periódicos y novedades'}
                                {comunicacionForm.tipo === 'promocion' && '🎉 Úsalo para ofertas especiales y promociones'}
                                {comunicacionForm.tipo === 'bienvenida' && '👋 Mensaje de bienvenida para nuevos usuarios'}
                            </p>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', color: '#ddd', marginBottom: '8px', fontWeight: 'bold' }}>
                                Asunto del Correo *
                            </label>
                            <input
                                type="text"
                                value={comunicacionForm.asunto}
                                onChange={(e) => setComunicacionForm({ ...comunicacionForm, asunto: e.target.value })}
                                placeholder="Ej: Nueva funcionalidad disponible"
                                style={inputStyle}
                                maxLength={100}
                            />
                            <p style={{ fontSize: '12px', color: '#999', marginTop: '5px', textAlign: 'right' }}>
                                {comunicacionForm.asunto.length}/100 caracteres
                            </p>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', color: '#ddd', marginBottom: '8px', fontWeight: 'bold' }}>
                                Mensaje *
                            </label>
                            <textarea
                                value={comunicacionForm.mensaje}
                                onChange={(e) => setComunicacionForm({ ...comunicacionForm, mensaje: e.target.value })}
                                placeholder="Escribe aquí el mensaje que se enviará a todos los usuarios verificados..."
                                style={{
                                    ...inputStyle,
                                    minHeight: '150px',
                                    resize: 'vertical',
                                    fontFamily: 'inherit'
                                }}
                                maxLength={1000}
                            />
                            <p style={{ fontSize: '12px', color: '#999', marginTop: '5px', textAlign: 'right' }}>
                                {comunicacionForm.mensaje.length}/1000 caracteres
                            </p>
                        </div>

                        <div style={{
                            background: 'rgba(255, 215, 0, 0.1)',
                            border: '1px solid rgba(255, 215, 0, 0.3)',
                            borderRadius: '8px',
                            padding: '15px',
                            marginBottom: '20px'
                        }}>
                            <p style={{ color: '#ffd700', margin: 0, fontSize: '14px' }}>
                                ⚠️ <strong>Importante:</strong> Este mensaje se enviará a todos los usuarios con email verificado.
                                Asegúrate de revisar el contenido antes de enviar.
                            </p>
                        </div>

                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                            <button
                                onClick={() => setShowComunicacionModal(false)}
                                style={{
                                    padding: '12px 24px',
                                    borderRadius: '8px',
                                    border: '1px solid #666',
                                    background: 'transparent',
                                    color: '#ddd',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    fontSize: '14px'
                                }}
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleEnviarComunicacionMasiva}
                                disabled={!comunicacionForm.asunto.trim() || !comunicacionForm.mensaje.trim()}
                                style={{
                                    padding: '12px 24px',
                                    borderRadius: '8px',
                                    border: 'none',
                                    background: (!comunicacionForm.asunto.trim() || !comunicacionForm.mensaje.trim())
                                        ? '#666'
                                        : 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    cursor: (!comunicacionForm.asunto.trim() || !comunicacionForm.mensaje.trim())
                                        ? 'not-allowed'
                                        : 'pointer',
                                    fontSize: '14px',
                                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
                                }}
                            >
                                📧 Enviar a Todos
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL HISTORIAL VENTA BNB */}
            {showHistorialVenta && (
                <div style={modalOverlayStyle} onClick={() => setShowHistorialVenta(false)}>
                    <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h3 style={{ margin: 0, color: '#4caf50' }}>📊 Historial de BNB</h3>
                            <button onClick={() => setShowHistorialVenta(false)} style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: '1.5rem', cursor: 'pointer' }}>×</button>
                        </div>

                        {loadingHistorial ? (
                            <p style={{ textAlign: 'center', color: '#aaa' }}>Cargando historial...</p>
                        ) : (
                            <>
                                {historialVenta.length === 0 ? (
                                    <p style={{ textAlign: 'center', color: '#aaa' }}>No hay transacciones registradas para este contrato.</p>
                                ) : (
                                    <>
                                        <div style={{ marginBottom: '20px', padding: '15px', background: 'rgba(76, 175, 80, 0.1)', borderRadius: '8px', border: '1px solid #4caf50' }}>
                                            <h4 style={{ margin: '0 0 10px 0', color: '#4caf50' }}>📈 Auditoría</h4>
                                            <div style={{ display: 'grid', gap: '8px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Total Transacciones:</span>
                                                    <span style={{ color: '#fff', fontWeight: 'bold' }}>{historialVenta.length}</span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Total BNB Vendido:</span>
                                                    <span style={{ color: '#f44336', fontWeight: 'bold' }}>
                                                        {historialVenta.filter(tx => tx.tipo === 'venta').reduce((sum, tx) => sum + parseFloat(tx.bnbAmount || 0), 0).toFixed(4)} BNB
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Total BNB Comprado:</span>
                                                    <span style={{ color: '#4caf50', fontWeight: 'bold' }}>
                                                        {historialVenta.filter(tx => tx.tipo === 'compra').reduce((sum, tx) => sum + parseFloat(tx.bnbAmount || 0), 0).toFixed(4)} BNB
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Total BNB Cargado:</span>
                                                    <span style={{ color: '#4caf50', fontWeight: 'bold' }}>
                                                        {historialVenta.filter(tx => tx.tipo === 'carga').reduce((sum, tx) => sum + parseFloat(tx.bnbAmount || 0), 0).toFixed(4)} BNB
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Total BNB Retirado:</span>
                                                    <span style={{ color: '#ff9800', fontWeight: 'bold' }}>
                                                        {historialVenta.filter(tx => tx.tipo === 'retiro').reduce((sum, tx) => sum + parseFloat(tx.bnbAmount || 0), 0).toFixed(4)} BNB
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Balance Actual Contrato:</span>
                                                    <span style={{ color: '#ffd700', fontWeight: 'bold' }}>{parseFloat(bnbAtmBalance).toFixed(4)} BNB</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <thead style={{ position: 'sticky', top: 0, background: '#2d2d3f' }}>
                                                    <tr style={{ borderBottom: '2px solid #4caf50' }}>
                                                        <th style={{ padding: '10px', textAlign: 'left', color: '#4caf50' }}>Fecha</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', color: '#4caf50' }}>Tipo</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', color: '#4caf50' }}>Usuario</th>
                                                        <th style={{ padding: '10px', textAlign: 'right', color: '#4caf50' }}>BNB</th>
                                                        <th style={{ padding: '10px', textAlign: 'right', color: '#4caf50' }}>Saldo</th>
                                                        <th style={{ padding: '10px', textAlign: 'center', color: '#4caf50' }}>TX</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(() => {
                                                        // Calcular saldos históricos (orden cronológico: más antiguo primero)
                                                        const sortedTxs = [...historialVenta].sort((a, b) => a.timestamp - b.timestamp);
                                                        let runningBalance = 0;
                                                        const txsWithBalance = sortedTxs.map(tx => {
                                                            const amount = parseFloat(tx.bnbAmount || 0);
                                                            // SUMAN (entran BNB al cajero): carga, compra (cajero compra BNB del usuario)
                                                            // RESTAN (salen BNB del cajero): venta (cajero vende BNB al usuario), retiro
                                                            if (tx.tipo === 'carga' || tx.tipo === 'compra') {
                                                                runningBalance += amount;
                                                            } else {
                                                                runningBalance -= amount;
                                                            }
                                                            return { ...tx, saldo: runningBalance };
                                                        });
                                                        // Mostrar en orden más reciente primero
                                                        return txsWithBalance.reverse().map((tx, idx) => {
                                                            let tipoColor, tipoLabel, isPositive;
                                                            if (tx.tipo === 'carga') {
                                                                tipoColor = '#4caf50';
                                                                tipoLabel = '⬆️ Carga';
                                                                isPositive = true;
                                                            } else if (tx.tipo === 'compra') {
                                                                tipoColor = '#4caf50';
                                                                tipoLabel = '⬆️ Compra';
                                                                isPositive = true;
                                                            } else if (tx.tipo === 'venta') {
                                                                tipoColor = '#f44336';
                                                                tipoLabel = '⬇️ Venta';
                                                                isPositive = false;
                                                            } else {
                                                                tipoColor = '#ff9800';
                                                                tipoLabel = '⬇️ Retiro';
                                                                isPositive = false;
                                                            }
                                                            return (
                                                                <tr key={idx} style={{ borderBottom: '1px solid #444' }}>
                                                                    <td style={{ padding: '10px', color: '#ddd', fontSize: '0.85rem' }}>
                                                                        {new Date(tx.timestamp).toLocaleString('es-CL')}
                                                                    </td>
                                                                    <td style={{ padding: '10px', color: tipoColor, fontSize: '0.85rem', fontWeight: 'bold' }}>
                                                                        {tipoLabel}
                                                                    </td>
                                                                    <td style={{ padding: '10px', color: '#ddd', fontSize: '0.85rem', fontFamily: 'monospace' }}>
                                                                        {tx.usuario ? (tx.usuario.length > 10 ? `${tx.usuario.slice(0, 6)}...${tx.usuario.slice(-4)}` : tx.usuario) : '-'}
                                                                    </td>
                                                                    <td style={{ padding: '10px', textAlign: 'right', color: tipoColor, fontWeight: 'bold' }}>
                                                                        {isPositive ? '+' : '-'}{parseFloat(tx.bnbAmount || 0).toFixed(4)}
                                                                    </td>
                                                                    <td style={{ padding: '10px', textAlign: 'right', color: '#00d2ff', fontWeight: 'bold' }}>
                                                                        {tx.saldo.toFixed(4)}
                                                                    </td>
                                                                    <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                        {tx.txHash ? (
                                                                            <a
                                                                                href={`https://bscscan.com/tx/${tx.txHash}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{ color: '#00d2ff', textDecoration: 'none', fontSize: '0.85rem' }}
                                                                            >
                                                                                Ver
                                                                            </a>
                                                                        ) : '-'}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        });
                                                    })()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            )}

            {/* MODAL HISTORIAL COMPRA BNB */}
            {showHistorialCompra && (
                <div style={modalOverlayStyle} onClick={() => setShowHistorialCompra(false)}>
                    <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h3 style={{ margin: 0, color: '#ff9800' }}>📊 Historial USDT</h3>
                            <button onClick={() => setShowHistorialCompra(false)} style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: '1.5rem', cursor: 'pointer' }}>×</button>
                        </div>

                        {loadingHistorial ? (
                            <p style={{ textAlign: 'center', color: '#aaa' }}>Cargando historial...</p>
                        ) : (
                            <>
                                {historialCompra.length === 0 ? (
                                    <p style={{ textAlign: 'center', color: '#aaa' }}>No hay transacciones registradas para este contrato.</p>
                                ) : (
                                    <>
                                        <div style={{ marginBottom: '20px', padding: '15px', background: 'rgba(255, 152, 0, 0.1)', borderRadius: '8px', border: '1px solid #ff9800' }}>
                                            <h4 style={{ margin: '0 0 10px 0', color: '#ff9800' }}>📈 Auditoría</h4>
                                            <div style={{ display: 'grid', gap: '8px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Total Transacciones:</span>
                                                    <span style={{ color: '#fff', fontWeight: 'bold' }}>{historialCompra.filter(tx => parseFloat(tx.usdtAmount || 0) > 0).length}</span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Total USDT Pagado:</span>
                                                    <span style={{ color: '#f44336', fontWeight: 'bold' }}>
                                                        ${historialCompra.filter(tx => tx.tipo === 'venta').reduce((sum, tx) => sum + parseFloat(tx.usdtAmount || 0), 0).toFixed(2)}
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Total USDT Recaudado:</span>
                                                    <span style={{ color: '#4caf50', fontWeight: 'bold' }}>
                                                        ${historialCompra.filter(tx => tx.tipo === 'compra').reduce((sum, tx) => sum + parseFloat(tx.usdtAmount || 0), 0).toFixed(2)}
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Total USDT Cargado:</span>
                                                    <span style={{ color: '#4caf50', fontWeight: 'bold' }}>
                                                        ${historialCompra.filter(tx => tx.tipo === 'carga' || tx.tipo === 'deposito').reduce((sum, tx) => sum + parseFloat(tx.usdtAmount || 0), 0).toFixed(2)}
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Total USDT Retirado:</span>
                                                    <span style={{ color: '#ff9800', fontWeight: 'bold' }}>
                                                        ${historialCompra.filter(tx => tx.tipo === 'retiro').reduce((sum, tx) => sum + parseFloat(tx.usdtAmount || 0), 0).toFixed(2)}
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <span style={{ color: '#aaa' }}>Balance Actual Contrato:</span>
                                                    <span style={{ color: '#ffd700', fontWeight: 'bold' }}>${parseFloat(bnbBuybackUSDT).toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <thead style={{ position: 'sticky', top: 0, background: '#2d2d3f' }}>
                                                    <tr style={{ borderBottom: '2px solid #ff9800' }}>
                                                        <th style={{ padding: '10px', textAlign: 'left', color: '#ff9800' }}>Fecha</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', color: '#ff9800' }}>Tipo</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', color: '#ff9800' }}>Usuario</th>
                                                        <th style={{ padding: '10px', textAlign: 'right', color: '#ff9800' }}>USDT</th>
                                                        <th style={{ padding: '10px', textAlign: 'right', color: '#ff9800' }}>Saldo</th>
                                                        <th style={{ padding: '10px', textAlign: 'center', color: '#ff9800' }}>TX</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(() => {
                                                        // Filtrar transacciones con USDT = 0
                                                        const filteredTxs = historialCompra.filter(tx => parseFloat(tx.usdtAmount || 0) > 0);
                                                        
                                                        // Calcular saldos históricos (orden cronológico: más antiguo primero)
                                                        const sortedTxs = [...filteredTxs].sort((a, b) => a.timestamp - b.timestamp);
                                                        let runningBalance = 0;
                                                        const txsWithBalance = sortedTxs.map(tx => {
                                                            const amount = parseFloat(tx.usdtAmount || 0);
                                                            // SUMAN (entran USDT al contrato):
                                                            // - deposito/carga: owner deposita
                                                            // - compra: usuario compra BNB, paga USDT al contrato (Recaudado)
                                                            // RESTAN (salen USDT del contrato):
                                                            // - venta: usuario vende BNB, recibe USDT del contrato (Pagado)
                                                            // - retiro: owner retira
                                                            if (tx.tipo === 'carga' || tx.tipo === 'deposito' || tx.tipo === 'compra') {
                                                                runningBalance += amount;
                                                            } else {
                                                                runningBalance -= amount;
                                                            }
                                                            return { ...tx, saldo: runningBalance };
                                                        });
                                                        // Mostrar en orden más reciente primero
                                                        return txsWithBalance.reverse().map((tx, idx) => {
                                                            // Mapear tipos: deposito->Carga, compra->Pagado, venta->Recaudado, retiro->Retiro
                                                            let tipoLabel = '';
                                                            let tipoColor = '';
                                                            let isPositive = false;
                                                            
                                                            if (tx.tipo === 'carga' || tx.tipo === 'deposito') {
                                                                tipoLabel = '⬆️ Carga';
                                                                tipoColor = '#4caf50';
                                                                isPositive = true;
                                                            } else if (tx.tipo === 'retiro') {
                                                                tipoLabel = '⬇️ Retiro';
                                                                tipoColor = '#f44336';
                                                                isPositive = false;
                                                            } else if (tx.tipo === 'compra') {
                                                                tipoLabel = '💵 Recaudado';
                                                                tipoColor = '#4caf50';
                                                                isPositive = true;
                                                            } else if (tx.tipo === 'venta') {
                                                                tipoLabel = '💰 Pagado';
                                                                tipoColor = '#f44336';
                                                                isPositive = false;
                                                            }
                                                            return (
                                                                <tr key={idx} style={{ borderBottom: '1px solid #444' }}>
                                                                    <td style={{ padding: '10px', color: '#ddd', fontSize: '0.85rem' }}>
                                                                        {new Date(tx.timestamp).toLocaleString('es-CL')}
                                                                    </td>
                                                                    <td style={{ padding: '10px', color: tipoColor, fontSize: '0.85rem', fontWeight: 'bold' }}>
                                                                        {tipoLabel}
                                                                    </td>
                                                                    <td style={{ padding: '10px', color: '#ddd', fontSize: '0.85rem', fontFamily: 'monospace' }}>
                                                                        {tx.usuario ? (tx.usuario.length > 10 ? `${tx.usuario.slice(0, 6)}...${tx.usuario.slice(-4)}` : tx.usuario) : '-'}
                                                                    </td>
                                                                    <td style={{ padding: '10px', textAlign: 'right', color: tipoColor, fontWeight: 'bold' }}>
                                                                        {isPositive ? '+' : '-'}${parseFloat(tx.usdtAmount || 0).toFixed(2)}
                                                                    </td>
                                                                    <td style={{ padding: '10px', textAlign: 'right', color: '#00d2ff', fontWeight: 'bold' }}>
                                                                        ${tx.saldo.toFixed(2)}
                                                                    </td>
                                                                    <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                        {tx.txHash ? (
                                                                            <a
                                                                                href={`https://bscscan.com/tx/${tx.txHash}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{ color: '#00d2ff', textDecoration: 'none', fontSize: '0.85rem' }}
                                                                            >
                                                                                Ver
                                                                            </a>
                                                                        ) : '-'}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        });
                                                    })()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            )}

        </div>
    );
};

// --- STYLES HELPER ---
const boxStyle = { background: '#2d2d3f', padding: '15px', borderRadius: '10px', color: '#fff' };
const inputStyle = { padding: '10px', borderRadius: '5px', border: '1px solid #555', background: '#1a1a2e', color: 'white', width: '100%', boxSizing: 'border-box' };
const tabStyle = (isActive) => ({
    background: isActive ? '#ffd700' : 'rgba(255, 215, 0, 0.15)',
    color: isActive ? 'black' : '#ffd700',
    border: isActive ? 'none' : '1px solid rgba(255, 215, 0, 0.4)',
    padding: '8px 15px',
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: '5px',
    fontWeight: isActive ? 'bold' : 'normal',
    transition: 'all 0.2s ease'
});
const getStatusStyle = (status) => {
    switch (status) {
        case 'verified': return { color: '#4caf50', fontWeight: 'bold' };
        case 'pending': return { color: '#ff9800', fontWeight: 'bold' };
        default: return { color: '#aaa' };
    }
};

// Modal Styles
const modalOverlayStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
};
const modalContentStyle = {
    background: '#2d2d3f', padding: '30px', borderRadius: '10px',
    width: '90%', maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto',
    border: '1px solid #ffd700', boxShadow: '0 0 20px rgba(255, 215, 0, 0.2)',
    color: '#eee' // Enforce light text globally in modal
};
const infoRowStyle = { marginBottom: '8px', borderBottom: '1px solid #444', paddingBottom: '5px', display: 'flex', justifyContent: 'space-between', color: '#ddd' };

export default AdminView;
